import React, { useEffect } from 'react';
import { Euler, Spherical, Vector3 } from 'three';
import { useSnapshot } from 'valtio';
import { cameraState, configuratorState, state, setSaveImage, setMinDistance, setFrameProduct } from '../../../state';
import { useThree } from '@react-three/fiber';

const SaveImage = () => {
    
    const {camera, saveImage} = useSnapshot(cameraState);
    const {mainModelNames, quantity, usecase, dimension} = useSnapshot(state);
    const {wallConfigStates} = useSnapshot(configuratorState);
    const threeState = useThree();
    
    useEffect(()=>
    {
        if(saveImage)
        {
            setSaveImage(false);
            setMinDistance(0);
            let canvas = document.querySelector("#root canvas");
            document.querySelector('.scene-container').style.display = 'none';
            let originalCameraPosition = new Vector3().copy(camera.current.object.position);
            let originalCanvasSize = Object.assign({}, threeState.size);
            let doorSwings = [];
            let activeRoof = [];
            threeState.scene.traverse(obj=>{if(obj.name.includes('Door_Swing')) doorSwings.push(obj);});
            threeState.scene.traverseVisible(obj=>{if(obj.name.includes('Roof') || obj.name.includes('Green') || obj.name.includes('Concrete')) activeRoof.push(obj);});
            let cameraRot = new Euler(-Math.PI/2, 0, 0);
            //let cameraShot = new Spherical(5, 1.099481685545045, 0.9182395814235235);
            //camera.current.object.position.setFromSpherical(cameraShot);
            threeState.setSize(2286, 1044, true);
            //setFrameProduct(true);
            //var newPos = new Spherical().setFromVector3(camera.current.object.position);
            let camCartPos;
            if(dimension[0] > dimension[1])
            {
                // Wider than deep
                if(wallConfigStates.wall2.door !== "none") camCartPos = [-1, 0.25, 0];
                else if(wallConfigStates.wall4.door !== "none") camCartPos = [1, 0.25, 0];
                else if(wallConfigStates.wall1.door !== "none") camCartPos = [0, 0.25, 1];
                else if(wallConfigStates.wall3.door !== "none") camCartPos = [0, 0.25, -1];
            }
            else
            {
                // Deeper than wide
                if(wallConfigStates.wall1.door !== "none") camCartPos = [0, 0.25, 1];
                else if(wallConfigStates.wall3.door !== "none") camCartPos = [0, 0.25, -1];
                else if(wallConfigStates.wall2.door !== "none") camCartPos = [-1, 0.25, 0];
                else if(wallConfigStates.wall4.door !== "none") camCartPos = [1, 0.25, 0];
            }
            var newPos = new Spherical().setFromCartesianCoords(camCartPos[0], camCartPos[1], camCartPos[2]);
            newPos.radius = topDownCameraDistances[dimension[0]][dimension[1]];
            camera.current.object.position.setFromSpherical(newPos);
            //camera.current.minDistance = 0;
            setTimeout(()=>
            {
                console.log('render');
                let productImage = canvas.toDataURL("image/jpg");
                threeState.setSize(3508, 2480, true);
                camera.current.object.position.x = 0;
                camera.current.object.position.z = 0;
                camera.current.object.position.y = topDownCameraDistances[dimension[0]][dimension[1]];
                camera.current.object.rotation.copy(cameraRot);
                //camera.current.object.setFocalLength(200);
                doorSwings.forEach(doorSwing=>{doorSwing.visible = true;});
                activeRoof.forEach(roof=>{roof.visible = false;});

                setTimeout(()=>
                {
                    let productPlan = canvas.toDataURL("image/jpg");
                    doorSwings.forEach(doorSwing=>{doorSwing.visible = false;});
                    activeRoof.forEach(roof=>{roof.visible = true;});
                    let req = new XMLHttpRequest();
                    let url = 'https://assets.modeconfigurator.com/Libraries/PHP/MetroStor/Download%20Spec%20Sheet/index-USP.php';
                    req.open('POST', url, true);
                    req.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
                    req.onload = (response) => 
                    {
                        // https://garywaddell.com/2017/01/03/stream-a-pdf-from-a-javascript-asyncajax-call-in-your-browser/
                        let rawPDF = response.target.response;
                        let data = 'data:application/pdf;base64,' + rawPDF;
                        let link = document.createElement('a');
                        link.href = data;
                        link.download = `${'Your Configuration'}.pdf`;
                        link.type = "application/pdf";
                        link.click();
                        setTimeout(function ()
                        {
                            window.URL.revokeObjectURL(data);
                        }, 100);
                    };
                    let specText = '';
                    let noDoors = 0;
                    let doorPos = '';
                    let toAddress = document.getElementById("Email").value;
                    let name = document.getElementById("Name").value;
                    let phone = document.getElementById("Phone").value;
                    //let depth = (dimension[0] + 0.5) * 100;
                    //let width = (dimension[1] - 0.5) * 100;
                    for(let key in wallConfigStates)
                    {
                        if(key === 'active') continue;
                        specText+=`${key[0].toUpperCase() + key.slice(1).replace(/(\d)/, ' $1')}:${convertStructureName(wallConfigStates[key]['structure'])}${key !== 'roof' ? (wallConfigStates[key]['door'] === 'none' ? ',no door' : ',w/door,' + wallConfigStates[key]['security']) : ''}|`;
                        if(wallConfigStates[key]['door'] !== 'none')
                        {
                            noDoors++;
                            doorPos += `${key==='wall1' || key==='wall3' ? 'short' : 'long'}-${wallConfigStates[key]['door'] === 'center' ? 'center' : 'end' + (noDoors > 1 ? (wallConfigStates[key]['door'] === 'left' ? '1' : '2') : '')}+`;
                        }
                    }
                    specText = specText.slice(0, -1);
                    doorPos = doorPos.slice(0, -1);
                    let capacity = shedCapacities[usecase][mainModelNames[0]][noDoors-1][doorPos];
                    if(capacity === 'N/A' || capacity === undefined) capacity = 'Please get in touch with us to calculate the capacity';
                    else capacity += " " + (usecase === "Tall" ? "T2" : usecase) + (capacity > 1 ? 's' : '');
                    camera.current.object.position.copy(originalCameraPosition);
                    document.querySelector('.scene-container').style.display = 'block';
                    threeState.setSize(originalCanvasSize.width, originalCanvasSize.height,true);
                    setMinDistance(7.4);
                    req.send(`imgData=${productImage}&imgPlan=${productPlan}&specification=${specText}&type=${usecase}&width=${(dimension[0]/10).toFixed(1)}&depth=${(dimension[1]/10).toFixed(1)}&code=${mainModelNames[0]}&qty=${quantity}&capacity=${capacity}&toAddress=${toAddress}&name=${name}&phone=${phone}`);
                }, 500)
            }, 500);
        }
    },[saveImage]);
    
}

const convertStructureName = (structureName) => {
    let returnValue = structureName;
    if(structureName.includes('Timber') || structureName.includes('TGV'))
    {
        returnValue = 'Timber Panels';
    }
    else if(structureName.includes('STL'))
    {
        returnValue = 'Steel Panels'
    }
    else if(structureName.includes('Glass'))
    {
        returnValue = 'Glass Panels'
    }
    else if(structureName.includes('Zed'))
    {
        returnValue = 'Zed Panels'
    }
    else if(structureName.includes('FR'))
    {
        returnValue = 'Standard'
    }
    return returnValue;
}

const shedCapacities = {
    'Bin': {
        'PTH-36.26': [
            {
                'short-center':'1',
                'short-end':'1',
                'long-center':'2',
                'long-end':'1',
            },
            {
                'long-center+long-center':'2',
                'long-center+long-end1':'2',
                'long-center+long-end2':'2',
                'long-end1+long-center':'2',
                'long-end1+long-end1':'2',
                'long-end1+long-end2':'2',
                'long-end2+long-center':'2',
                'long-end2+long-end1':'2',
                'long-end2+long-end2':'2',
                'long-center+short-end1':'1',
                'long-center+short-end2':'1',
                'long-end1+short-end1':'1',
                'long-end2+short-end2':'1',
                'short-end1+long-center':'1',
                'short-end2+long-center':'1',
                'short-end1+long-end1':'1',
                'short-end2+long-end2':'1',
                'long-end2+short-end1':'1',
                'long-end1+short-end2':'1',
                'short-end2+long-end1':'1',
                'short-end1+long-end2':'1',
            },
            {},
            {}
        ]
    ,'PTH-36.32': [
            {
                'short-center':'2',
                'short-end':'3',
                'long-center':'4',
                'long-end':'3',
            },
            {
                'long-center+long-center':'4',
                'long-center+long-end1':'4',
                'long-center+long-end2':'4',
                'long-end1+long-center':'4',
                'long-end1+long-end1':'4',
                'long-end1+long-end2':'4',
                'long-end2+long-center':'4',
                'long-end2+long-end1':'4',
                'long-end2+long-end2':'4',
                'long-center+short-end1':'2',
                'long-center+short-end2':'2',
                'long-end1+short-end1':'2',
                'long-end2+short-end2':'2',
                'short-end1+long-center':'2',
                'short-end2+long-center':'2',
                'short-end1+long-end1':'2',
                'short-end2+long-end2':'2',
                'long-end2+short-end1':'2',
                'long-end1+short-end2':'2',
                'short-end2+long-end1':'2',
                'short-end1+long-end2':'2',
            },
            {},
            {}
        ]
    ,'PTH-36.50': [
            {
                'short-center':'6',
                'short-end':'5',
                'long-center':'5',
                'long-end':'5',
            },
            {
                'long-center+long-center':'4',
                'long-center+long-end1':'4',
                'long-center+long-end2':'4',
                'long-end1+long-center':'4',
                'long-end1+long-end1':'4',
                'long-end1+long-end2':'4',
                'long-end2+long-center':'4',
                'long-end2+long-end1':'4',
                'long-end2+long-end2':'4',
                'long-center+short-end1':'4',
                'long-center+short-end2':'4',
                'long-end1+short-end1':'4',
                'long-end2+short-end2':'4',
                'short-end1+long-center':'4',
                'short-end2+long-center':'4',
                'short-end1+long-end1':'4',
                'short-end2+long-end2':'4',
                'long-end2+short-end1':'4',
                'long-end1+short-end2':'4',
                'short-end2+long-end1':'4',
                'short-end1+long-end2':'4',
            },
            {},
            {}
        ]
    ,'PTH-36.62': [
            {
                'short-center':'8',
                'short-end':'7',
                'long-center':'6',
                'long-end':'7',
            },
            {
                'long-center+long-center':'4',
                'long-center+long-end1':'4',
                'long-center+long-end2':'4',
                'long-end1+long-center':'4',
                'long-end1+long-end1':'4',
                'long-end1+long-end2':'4',
                'long-end2+long-center':'4',
                'long-end2+long-end1':'4',
                'long-end2+long-end2':'4',
                'long-center+short-end1':'5',
                'long-center+short-end2':'5',
                'long-end1+short-end1':'5',
                'long-end2+short-end2':'5',
                'short-end1+long-center':'5',
                'short-end2+long-center':'5',
                'short-end1+long-end1':'5',
                'short-end2+long-end2':'5',
                'long-end2+short-end1':'5',
                'long-end1+short-end2':'5',
                'short-end2+long-end1':'5',
                'short-end1+long-end2':'5',
            },
            {},
            {}
        ]
    ,'PTH-36.74': [
            {
                'short-center':'10',
                'short-end':'9',
                'long-center':'8',
                'long-end':'9',
            },
            {
                'long-center+long-center':'6',
                'long-center+long-end1':'6',
                'long-center+long-end2':'6',
                'long-end1+long-center':'6',
                'long-end1+long-end1':'6',
                'long-end1+long-end2':'6',
                'long-end2+long-center':'6',
                'long-end2+long-end1':'6',
                'long-end2+long-end2':'6',
                'long-center+short-end1':'7',
                'long-center+short-end2':'7',
                'long-end1+short-end1':'7',
                'long-end2+short-end2':'7',
                'short-end1+long-center':'7',
                'short-end2+long-center':'7',
                'short-end1+long-end1':'7',
                'short-end2+long-end2':'7',
                'long-end2+short-end1':'7',
                'long-end1+short-end2':'7',
                'short-end2+long-end1':'7',
                'short-end1+long-end2':'7',
            },
            {},
            {}
        ]
    ,'PTH-36.92': [
            {
                'short-center':'12',
                'short-end':'11',
                'long-center':'10',
                'long-end':'11',
            },
            {
                'long-center+long-center':'8',
                'long-center+long-end1':'8',
                'long-center+long-end2':'8',
                'long-end1+long-center':'8',
                'long-end1+long-end1':'8',
                'long-end1+long-end2':'8',
                'long-end2+long-center':'8',
                'long-end2+long-end1':'8',
                'long-end2+long-end2':'8',
                'long-center+short-end1':'9',
                'long-center+short-end2':'9',
                'long-end1+short-end1':'9',
                'long-end2+short-end2':'9',
                'short-end1+long-center':'9',
                'short-end2+long-center':'9',
                'short-end1+long-end1':'9',
                'short-end2+long-end2':'9',
                'long-end2+short-end1':'9',
                'long-end1+short-end2':'9',
                'short-end2+long-end1':'9',
                'short-end1+long-end2':'9',
            },
            {},
            {}
        ]
    ,'PTH-48.26': [
            {
                'short-center':'2',
                'short-end':'3',
                'long-center':'4',
                'long-end':'3',
            },
            {
                'long-center+long-center':'4',
                'long-center+long-end1':'4',
                'long-center+long-end2':'4',
                'long-end1+long-center':'4',
                'long-end1+long-end1':'4',
                'long-end1+long-end2':'4',
                'long-end2+long-center':'4',
                'long-end2+long-end1':'4',
                'long-end2+long-end2':'4',
                'long-center+short-end1':'3',
                'long-center+short-end2':'3',
                'long-end1+short-end1':'3',
                'long-end2+short-end2':'3',
                'short-end1+long-center':'3',
                'short-end2+long-center':'3',
                'short-end1+long-end1':'3',
                'short-end2+long-end2':'3',
                'long-end2+short-end1':'3',
                'long-end1+short-end2':'3',
                'short-end2+long-end1':'3',
                'short-end1+long-end2':'3',
            },
            {},
            {}
        ]
    ,'PTH-48.38': [
            {
                'short-center':'5',
                'short-end':'5',
                'long-center':'6',
                'long-end':'5',
            },
            {
                'long-center+long-center':'6',
                'long-center+long-end1':'6',
                'long-center+long-end2':'6',
                'long-end1+long-center':'6',
                'long-end1+long-end1':'6',
                'long-end1+long-end2':'6',
                'long-end2+long-center':'6',
                'long-end2+long-end1':'6',
                'long-end2+long-end2':'6',
                'long-center+short-end1':'5',
                'long-center+short-end2':'5',
                'long-end1+short-end1':'5',
                'long-end2+short-end2':'5',
                'short-end1+long-center':'5',
                'short-end2+long-center':'5',
                'short-end1+long-end1':'5',
                'short-end2+long-end2':'5',
                'long-end2+short-end1':'5',
                'long-end1+short-end2':'5',
                'short-end2+long-end1':'5',
                'short-end1+long-end2':'5',
            },
            {},
            {}
        ]
    ,'PTH-48.50': [
            {
                'short-center':'6',
                'short-end':'6',
                'long-center':'8',
                'long-end':'6',
            },
            {
                'long-center+long-center':'8',
                'long-center+long-end1':'8',
                'long-center+long-end2':'8',
                'long-end1+long-center':'8',
                'long-end1+long-end1':'8',
                'long-end1+long-end2':'8',
                'long-end2+long-center':'8',
                'long-end2+long-end1':'8',
                'long-end2+long-end2':'8',
                'long-center+short-end1':'7',
                'long-center+short-end2':'7',
                'long-end1+short-end1':'7',
                'long-end2+short-end2':'7',
                'short-end1+long-center':'7',
                'short-end2+long-center':'7',
                'short-end1+long-end1':'7',
                'short-end2+long-end2':'7',
                'long-end2+short-end1':'7',
                'long-end1+short-end2':'7',
                'short-end2+long-end1':'7',
                'short-end1+long-end2':'7',
            },
            {},
            {}
        ]
    ,'PTH-48.62': [
            {
                'short-center':'10',
                'short-end':'9',
                'long-center':'9',
                'long-end':'9',
            },
            {
                'long-center+long-center':'8',
                'long-center+long-end1':'8',
                'long-center+long-end2':'8',
                'long-end1+long-center':'8',
                'long-end1+long-end1':'8',
                'long-end1+long-end2':'8',
                'long-end2+long-center':'8',
                'long-end2+long-end1':'8',
                'long-end2+long-end2':'8',
                'long-center+short-end1':'8',
                'long-center+short-end2':'8',
                'long-end1+short-end1':'8',
                'long-end2+short-end2':'8',
                'short-end1+long-center':'8',
                'short-end2+long-center':'8',
                'short-end1+long-end1':'8',
                'short-end2+long-end2':'8',
                'long-end2+short-end1':'8',
                'long-end1+short-end2':'8',
                'short-end2+long-end1':'8',
                'short-end1+long-end2':'8',
            },
            {},
            {}
        ]
    ,'PTH-48.74': [
            {
                'short-center':'12',
                'short-end':'11',
                'long-center':'11',
                'long-end':'11',
            },
            {
                'long-center+long-center':'10',
                'long-center+long-end1':'10',
                'long-center+long-end2':'10',
                'long-end1+long-center':'10',
                'long-end1+long-end1':'10',
                'long-end1+long-end2':'10',
                'long-end2+long-center':'10',
                'long-end2+long-end1':'10',
                'long-end2+long-end2':'10',
                'long-center+short-end1':'10',
                'long-center+short-end2':'10',
                'long-end1+short-end1':'10',
                'long-end2+short-end2':'10',
                'short-end1+long-center':'10',
                'short-end2+long-center':'10',
                'short-end1+long-end1':'10',
                'short-end2+long-end2':'10',
                'long-end2+short-end1':'10',
                'long-end1+short-end2':'10',
                'short-end2+long-end1':'10',
                'short-end1+long-end2':'10',
            },
            {},
            {}
        ]
    ,'PTH-48.86': [
            {
                'short-center':'14',
                'short-end':'13',
                'long-center':'13',
                'long-end':'13',
            },
            {
                'long-center+long-center':'12',
                'long-center+long-end1':'12',
                'long-center+long-end2':'12',
                'long-end1+long-center':'12',
                'long-end1+long-end1':'12',
                'long-end1+long-end2':'12',
                'long-end2+long-center':'12',
                'long-end2+long-end1':'12',
                'long-end2+long-end2':'12',
                'long-center+short-end1':'12',
                'long-center+short-end2':'12',
                'long-end1+short-end1':'12',
                'long-end2+short-end2':'12',
                'short-end1+long-center':'12',
                'short-end2+long-center':'12',
                'short-end1+long-end1':'12',
                'short-end2+long-end2':'12',
                'long-end2+short-end1':'12',
                'long-end1+short-end2':'12',
                'short-end2+long-end1':'12',
                'short-end1+long-end2':'12',
            },
            {},
            {}
        ]
    ,'PTH-48.98': [
            {
                'short-center':'16',
                'short-end':'15',
                'long-center':'15',
                'long-end':'15',
            },
            {
                'long-center+long-center':'14',
                'long-center+long-end1':'14',
                'long-center+long-end2':'14',
                'long-end1+long-center':'14',
                'long-end1+long-end1':'14',
                'long-end1+long-end2':'14',
                'long-end2+long-center':'14',
                'long-end2+long-end1':'14',
                'long-end2+long-end2':'14',
                'long-center+short-end1':'14',
                'long-center+short-end2':'14',
                'long-end1+short-end1':'14',
                'long-end2+short-end2':'14',
                'short-end1+long-center':'14',
                'short-end2+long-center':'14',
                'short-end1+long-end1':'14',
                'short-end2+long-end2':'14',
                'long-end2+short-end1':'14',
                'long-end1+short-end2':'14',
                'short-end2+long-end1':'14',
                'short-end1+long-end2':'14',
            },
            {},
            {}
        ]
    ,'PTH-48.110': [
            {
                'short-center':'18',
                'short-end':'17',
                'long-center':'17',
                'long-end':'17',
            },
            {
                'long-center+long-center':'16',
                'long-center+long-end1':'16',
                'long-center+long-end2':'16',
                'long-end1+long-center':'16',
                'long-end1+long-end1':'16',
                'long-end1+long-end2':'16',
                'long-end2+long-center':'16',
                'long-end2+long-end1':'16',
                'long-end2+long-end2':'16',
                'long-center+short-end1':'16',
                'long-center+short-end2':'16',
                'long-end1+short-end1':'16',
                'long-end2+short-end2':'16',
                'short-end1+long-center':'16',
                'short-end2+long-center':'16',
                'short-end1+long-end1':'16',
                'short-end2+long-end2':'16',
                'long-end2+short-end1':'16',
                'long-end1+short-end2':'16',
                'short-end2+long-end1':'16',
                'short-end1+long-end2':'16',
            },
            {},
            {}
        ]
    ,'PTH-48.122': [
            {
                'short-center':'20',
                'short-end':'19',
                'long-center':'19',
                'long-end':'19',
            },
            {
                'long-center+long-center':'18',
                'long-center+long-end1':'18',
                'long-center+long-end2':'18',
                'long-end1+long-center':'18',
                'long-end1+long-end1':'18',
                'long-end1+long-end2':'18',
                'long-end2+long-center':'18',
                'long-end2+long-end1':'18',
                'long-end2+long-end2':'18',
                'long-center+short-end1':'18',
                'long-center+short-end2':'18',
                'long-end1+short-end1':'18',
                'long-end2+short-end2':'18',
                'short-end1+long-center':'18',
                'short-end2+long-center':'18',
                'short-end1+long-end1':'18',
                'short-end2+long-end2':'18',
                'long-end2+short-end1':'18',
                'long-end1+short-end2':'18',
                'short-end2+long-end1':'18',
                'short-end1+long-end2':'18',
            },
            {},
            {}
        ]
    ,'PTH-48.134': [
            {
                'short-center':'22',
                'short-end':'21',
                'long-center':'21',
                'long-end':'21',
            },
            {
                'long-center+long-center':'20',
                'long-center+long-end1':'20',
                'long-center+long-end2':'20',
                'long-end1+long-center':'20',
                'long-end1+long-end1':'20',
                'long-end1+long-end2':'20',
                'long-end2+long-center':'20',
                'long-end2+long-end1':'20',
                'long-end2+long-end2':'20',
                'long-center+short-end1':'20',
                'long-center+short-end2':'20',
                'long-end1+short-end1':'20',
                'long-end2+short-end2':'20',
                'short-end1+long-center':'20',
                'short-end2+long-center':'20',
                'short-end1+long-end1':'20',
                'short-end2+long-end2':'20',
                'long-end2+short-end1':'20',
                'long-end1+short-end2':'20',
                'short-end2+long-end1':'20',
                'short-end1+long-end2':'20',
            },
            {},
            {}
        ]
    ,'PTH-48.146': [
            {
                'short-center':'24',
                'short-end':'23',
                'long-center':'23',
                'long-end':'23',
            },
            {
                'long-center+long-center':'22',
                'long-center+long-end1':'22',
                'long-center+long-end2':'22',
                'long-end1+long-center':'22',
                'long-end1+long-end1':'22',
                'long-end1+long-end2':'22',
                'long-end2+long-center':'22',
                'long-end2+long-end1':'22',
                'long-end2+long-end2':'22',
                'long-center+short-end1':'22',
                'long-center+short-end2':'22',
                'long-end1+short-end1':'22',
                'long-end2+short-end2':'22',
                'short-end1+long-center':'22',
                'short-end2+long-center':'22',
                'short-end1+long-end1':'22',
                'short-end2+long-end2':'22',
                'long-end2+short-end1':'22',
                'long-end1+short-end2':'22',
                'short-end2+long-end1':'22',
                'short-end1+long-end2':'22',
            },
            {},
            {}
        ]
    },
    'Hoop': {
        'PTH-30.26': [
            {
                'short-center':'6',
                'short-end':'6',
                'long-center':'2',
                'long-end':'6',
            },
            {
                'long-center+long-center':'N/A',
                'long-center+long-end1':'N/A',
                'long-center+long-end2':'N/A',
                'long-end1+long-center':'N/A',
                'long-end1+long-end1':'N/A',
                'long-end1+long-end2':'N/A',
                'long-end2+long-center':'N/A',
                'long-end2+long-end1':'N/A',
                'long-end2+long-end2':'N/A',
                'long-center+short-end1':'6',
                'long-center+short-end2':'6',
                'long-end1+short-end1':'6',
                'long-end2+short-end2':'6',
                'short-end1+long-center':'6',
                'short-end2+long-center':'6',
                'short-end1+long-end1':'6',
                'short-end2+long-end2':'6',
                'long-end2+short-end1':'6',
                'long-end1+short-end2':'6',
                'short-end2+long-end1':'6',
                'short-end1+long-end2':'6',
            },
            {},
            {}
        ]
    ,'PTH-30.32': [
            {
                'short-center':'4',
                'short-end':'8',
                'long-center':'8',
                'long-end':'8',
            },
            {
                'long-center+long-center':'4',
                'long-center+long-end1':'4',
                'long-center+long-end2':'4',
                'long-end1+long-center':'4',
                'long-end1+long-end1':'4',
                'long-end1+long-end2':'4',
                'long-end2+long-center':'4',
                'long-end2+long-end1':'4',
                'long-end2+long-end2':'4',
                'long-center+short-end1':'8',
                'long-center+short-end2':'8',
                'long-end1+short-end1':'8',
                'long-end2+short-end2':'8',
                'short-end1+long-center':'8',
                'short-end2+long-center':'8',
                'short-end1+long-end1':'8',
                'short-end2+long-end2':'8',
                'long-end2+short-end1':'8',
                'long-end1+short-end2':'8',
                'short-end2+long-end1':'8',
                'short-end1+long-end2':'8',
            },
            {},
            {}
        ]
    ,'PTH-30.44': [
            {
                'short-center':'6',
                'short-end':'10',
                'long-center':'10',
                'long-end':'10',
            },
            {
                'long-center+long-center':'6',
                'long-center+long-end1':'6',
                'long-center+long-end2':'6',
                'long-end1+long-center':'6',
                'long-end1+long-end1':'6',
                'long-end1+long-end2':'6',
                'long-end2+long-center':'6',
                'long-end2+long-end1':'6',
                'long-end2+long-end2':'6',
                'long-center+short-end1':'10',
                'long-center+short-end2':'10',
                'long-end1+short-end1':'10',
                'long-end2+short-end2':'10',
                'short-end1+long-center':'10',
                'short-end2+long-center':'10',
                'short-end1+long-end1':'10',
                'short-end2+long-end2':'10',
                'long-end2+short-end1':'10',
                'long-end1+short-end2':'10',
                'short-end2+long-end1':'10',
                'short-end1+long-end2':'10',
            },
            {},
            {}
        ]
    ,'PTH-30.50': [
            {
                'short-center':'8',
                'short-end':'12',
                'long-center':'12',
                'long-end':'12',
            },
            {
                'long-center+long-center':'8',
                'long-center+long-end1':'8',
                'long-center+long-end2':'8',
                'long-end1+long-center':'8',
                'long-end1+long-end1':'8',
                'long-end1+long-end2':'8',
                'long-end2+long-center':'8',
                'long-end2+long-end1':'8',
                'long-end2+long-end2':'8',
                'long-center+short-end1':'12',
                'long-center+short-end2':'12',
                'long-end1+short-end1':'12',
                'long-end2+short-end2':'12',
                'short-end1+long-center':'12',
                'short-end2+long-center':'12',
                'short-end1+long-end1':'12',
                'short-end2+long-end2':'12',
                'long-end2+short-end1':'12',
                'long-end1+short-end2':'12',
                'short-end2+long-end1':'12',
                'short-end1+long-end2':'12',
            },
            {},
            {}
        ]
    ,'PTH-30.56': [
            {
                'short-center':'10',
                'short-end':'14',
                'long-center':'14',
                'long-end':'14',
            },
            {
                'long-center+long-center':'10',
                'long-center+long-end1':'10',
                'long-center+long-end2':'10',
                'long-end1+long-center':'10',
                'long-end1+long-end1':'10',
                'long-end1+long-end2':'10',
                'long-end2+long-center':'10',
                'long-end2+long-end1':'10',
                'long-end2+long-end2':'10',
                'long-center+short-end1':'14',
                'long-center+short-end2':'14',
                'long-end1+short-end1':'14',
                'long-end2+short-end2':'14',
                'short-end1+long-center':'14',
                'short-end2+long-center':'14',
                'short-end1+long-end1':'14',
                'short-end2+long-end2':'14',
                'long-end2+short-end1':'14',
                'long-end1+short-end2':'14',
                'short-end2+long-end1':'14',
                'short-end1+long-end2':'14',
            },
            {},
            {}
        ]
    ,'PTH-30.68': [
            {
                'short-center':'12',
                'short-end':'16',
                'long-center':'16',
                'long-end':'16',
            },
            {
                'long-center+long-center':'12',
                'long-center+long-end1':'12',
                'long-center+long-end2':'12',
                'long-end1+long-center':'12',
                'long-end1+long-end1':'12',
                'long-end1+long-end2':'12',
                'long-end2+long-center':'12',
                'long-end2+long-end1':'12',
                'long-end2+long-end2':'12',
                'long-center+short-end1':'16',
                'long-center+short-end2':'16',
                'long-end1+short-end1':'16',
                'long-end2+short-end2':'16',
                'short-end1+long-center':'16',
                'short-end2+long-center':'16',
                'short-end1+long-end1':'16',
                'short-end2+long-end2':'16',
                'long-end2+short-end1':'16',
                'long-end1+short-end2':'16',
                'short-end2+long-end1':'16',
                'short-end1+long-end2':'16',
            },
            {},
            {}
        ]
    ,'PTH-30.74': [
            {
                'short-center':'14',
                'short-end':'18',
                'long-center':'18',
                'long-end':'18',
            },
            {
                'long-center+long-center':'14',
                'long-center+long-end1':'14',
                'long-center+long-end2':'14',
                'long-end1+long-center':'14',
                'long-end1+long-end1':'14',
                'long-end1+long-end2':'14',
                'long-end2+long-center':'14',
                'long-end2+long-end1':'14',
                'long-end2+long-end2':'14',
                'long-center+short-end1':'18',
                'long-center+short-end2':'18',
                'long-end1+short-end1':'18',
                'long-end2+short-end2':'18',
                'short-end1+long-center':'18',
                'short-end2+long-center':'18',
                'short-end1+long-end1':'18',
                'short-end2+long-end2':'18',
                'long-end2+short-end1':'18',
                'long-end1+short-end2':'18',
                'short-end2+long-end1':'18',
                'short-end1+long-end2':'18',
            },
            {},
            {}
        ]
    ,'PTH-30.80': [
            {
                'short-center':'16',
                'short-end':'20',
                'long-center':'20',
                'long-end':'20',
            },
            {
                'long-center+long-center':'16',
                'long-center+long-end1':'16',
                'long-center+long-end2':'16',
                'long-end1+long-center':'16',
                'long-end1+long-end1':'16',
                'long-end1+long-end2':'16',
                'long-end2+long-center':'16',
                'long-end2+long-end1':'16',
                'long-end2+long-end2':'16',
                'long-center+short-end1':'20',
                'long-center+short-end2':'20',
                'long-end1+short-end1':'20',
                'long-end2+short-end2':'20',
                'short-end1+long-center':'20',
                'short-end2+long-center':'20',
                'short-end1+long-end1':'20',
                'short-end2+long-end2':'20',
                'long-end2+short-end1':'20',
                'long-end1+short-end2':'20',
                'short-end2+long-end1':'20',
                'short-end1+long-end2':'20',
            },
            {},
            {}
        ]
    ,'PTH-30.92': [
            {
                'short-center':'18',
                'short-end':'22',
                'long-center':'22',
                'long-end':'22',
            },
            {
                'long-center+long-center':'18',
                'long-center+long-end1':'18',
                'long-center+long-end2':'18',
                'long-end1+long-center':'18',
                'long-end1+long-end1':'18',
                'long-end1+long-end2':'18',
                'long-end2+long-center':'18',
                'long-end2+long-end1':'18',
                'long-end2+long-end2':'18',
                'long-center+short-end1':'22',
                'long-center+short-end2':'22',
                'long-end1+short-end1':'22',
                'long-end2+short-end2':'22',
                'short-end1+long-center':'22',
                'short-end2+long-center':'22',
                'short-end1+long-end1':'22',
                'short-end2+long-end2':'22',
                'long-end2+short-end1':'22',
                'long-end1+short-end2':'22',
                'short-end2+long-end1':'22',
                'short-end1+long-end2':'22',
            },
            {},
            {}
        ]
    ,'PTH-30.98': [
            {
                'short-center':'20',
                'short-end':'24',
                'long-center':'24',
                'long-end':'24',
            },
            {
                'long-center+long-center':'20',
                'long-center+long-end1':'20',
                'long-center+long-end2':'20',
                'long-end1+long-center':'20',
                'long-end1+long-end1':'20',
                'long-end1+long-end2':'20',
                'long-end2+long-center':'20',
                'long-end2+long-end1':'20',
                'long-end2+long-end2':'20',
                'long-center+short-end1':'24',
                'long-center+short-end2':'24',
                'long-end1+short-end1':'24',
                'long-end2+short-end2':'24',
                'short-end1+long-center':'24',
                'short-end2+long-center':'24',
                'short-end1+long-end1':'24',
                'short-end2+long-end2':'24',
                'long-end2+short-end1':'24',
                'long-end1+short-end2':'24',
                'short-end2+long-end1':'24',
                'short-end1+long-end2':'24',
            },
            {},
            {}
        ]
    ,'PTH-30.104': [
            {
                'short-center':'22',
                'short-end':'26',
                'long-center':'26',
                'long-end':'26',
            },
            {
                'long-center+long-center':'22',
                'long-center+long-end1':'22',
                'long-center+long-end2':'22',
                'long-end1+long-center':'22',
                'long-end1+long-end1':'22',
                'long-end1+long-end2':'22',
                'long-end2+long-center':'22',
                'long-end2+long-end1':'22',
                'long-end2+long-end2':'22',
                'long-center+short-end1':'26',
                'long-center+short-end2':'26',
                'long-end1+short-end1':'26',
                'long-end2+short-end2':'26',
                'short-end1+long-center':'26',
                'short-end2+long-center':'26',
                'short-end1+long-end1':'26',
                'short-end2+long-end2':'26',
                'long-end2+short-end1':'26',
                'long-end1+short-end2':'26',
                'short-end2+long-end1':'26',
                'short-end1+long-end2':'26',
            },
            {},
            {}
        ]
    ,'PTH-30.116': [
            {
                'short-center':'24',
                'short-end':'28',
                'long-center':'28',
                'long-end':'28',
            },
            {
                'long-center+long-center':'24',
                'long-center+long-end1':'24',
                'long-center+long-end2':'24',
                'long-end1+long-center':'24',
                'long-end1+long-end1':'24',
                'long-end1+long-end2':'24',
                'long-end2+long-center':'24',
                'long-end2+long-end1':'24',
                'long-end2+long-end2':'24',
                'long-center+short-end1':'28',
                'long-center+short-end2':'28',
                'long-end1+short-end1':'28',
                'long-end2+short-end2':'28',
                'short-end1+long-center':'28',
                'short-end2+long-center':'28',
                'short-end1+long-end1':'28',
                'short-end2+long-end2':'28',
                'long-end2+short-end1':'28',
                'long-end1+short-end2':'28',
                'short-end2+long-end1':'28',
                'short-end1+long-end2':'28',
            },
            {},
            {}
        ]
    ,'PTH-30.122': [
            {
                'short-center':'26',
                'short-end':'30',
                'long-center':'30',
                'long-end':'30',
            },
            {
                'long-center+long-center':'26',
                'long-center+long-end1':'26',
                'long-center+long-end2':'26',
                'long-end1+long-center':'26',
                'long-end1+long-end1':'26',
                'long-end1+long-end2':'26',
                'long-end2+long-center':'26',
                'long-end2+long-end1':'26',
                'long-end2+long-end2':'26',
                'long-center+short-end1':'30',
                'long-center+short-end2':'30',
                'long-end1+short-end1':'30',
                'long-end2+short-end2':'30',
                'short-end1+long-center':'30',
                'short-end2+long-center':'30',
                'short-end1+long-end1':'30',
                'short-end2+long-end2':'30',
                'long-end2+short-end1':'30',
                'long-end1+short-end2':'30',
                'short-end2+long-end1':'30',
                'short-end1+long-end2':'30',
            },
            {},
            {}
        ]
    ,'PTH-30.128': [
            {
                'short-center':'28',
                'short-end':'32',
                'long-center':'32',
                'long-end':'32',
            },
            {
                'long-center+long-center':'28',
                'long-center+long-end1':'28',
                'long-center+long-end2':'28',
                'long-end1+long-center':'28',
                'long-end1+long-end1':'28',
                'long-end1+long-end2':'28',
                'long-end2+long-center':'28',
                'long-end2+long-end1':'28',
                'long-end2+long-end2':'28',
                'long-center+short-end1':'32',
                'long-center+short-end2':'32',
                'long-end1+short-end1':'32',
                'long-end2+short-end2':'32',
                'short-end1+long-center':'32',
                'short-end2+long-center':'32',
                'short-end1+long-end1':'32',
                'short-end2+long-end2':'32',
                'long-end2+short-end1':'32',
                'long-end1+short-end2':'32',
                'short-end2+long-end1':'32',
                'short-end1+long-end2':'32',
            },
            {},
            {}
        ]
    ,'PTH-30.140': [
            {
                'short-center':'30',
                'short-end':'34',
                'long-center':'34',
                'long-end':'34',
            },
            {
                'long-center+long-center':'30',
                'long-center+long-end1':'30',
                'long-center+long-end2':'30',
                'long-end1+long-center':'30',
                'long-end1+long-end1':'30',
                'long-end1+long-end2':'30',
                'long-end2+long-center':'30',
                'long-end2+long-end1':'30',
                'long-end2+long-end2':'30',
                'long-center+short-end1':'34',
                'long-center+short-end2':'34',
                'long-end1+short-end1':'34',
                'long-end2+short-end2':'34',
                'short-end1+long-center':'34',
                'short-end2+long-center':'34',
                'short-end1+long-end1':'34',
                'short-end2+long-end2':'34',
                'long-end2+short-end1':'34',
                'long-end1+short-end2':'34',
                'short-end2+long-end1':'34',
                'short-end1+long-end2':'34',
            },
            {},
            {}
        ]
    ,'PTH-30.140': [
            {
                'short-center':'32',
                'short-end':'36',
                'long-center':'36',
                'long-end':'36',
            },
            {
                'long-center+long-center':'32',
                'long-center+long-end1':'32',
                'long-center+long-end2':'32',
                'long-end1+long-center':'32',
                'long-end1+long-end1':'32',
                'long-end1+long-end2':'32',
                'long-end2+long-center':'32',
                'long-end2+long-end1':'32',
                'long-end2+long-end2':'32',
                'long-center+short-end1':'36',
                'long-center+short-end2':'36',
                'long-end1+short-end1':'36',
                'long-end2+short-end2':'36',
                'short-end1+long-center':'36',
                'short-end2+long-center':'36',
                'short-end1+long-end1':'36',
                'short-end2+long-end2':'36',
                'long-end2+short-end1':'36',
                'long-end1+short-end2':'36',
                'short-end2+long-end1':'36',
                'short-end1+long-end2':'36',
            },
            {},
            {}
        ]
    ,'PTH-30.152': [
            {
                'short-center':'34',
                'short-end':'38',
                'long-center':'38',
                'long-end':'38',
            },
            {
                'long-center+long-center':'34',
                'long-center+long-end1':'34',
                'long-center+long-end2':'34',
                'long-end1+long-center':'34',
                'long-end1+long-end1':'34',
                'long-end1+long-end2':'34',
                'long-end2+long-center':'34',
                'long-end2+long-end1':'34',
                'long-end2+long-end2':'34',
                'long-center+short-end1':'38',
                'long-center+short-end2':'38',
                'long-end1+short-end1':'38',
                'long-end2+short-end2':'38',
                'short-end1+long-center':'38',
                'short-end2+long-center':'38',
                'short-end1+long-end1':'38',
                'short-end2+long-end2':'38',
                'long-end2+short-end1':'38',
                'long-end1+short-end2':'38',
                'short-end2+long-end1':'38',
                'short-end1+long-end2':'38',
            },
            {},
            {}
        ]
    ,'PTH-48.26': [
            {
                'short-center':'6',
                'short-end':'8',
                'long-center':'12',
                'long-end':'8',
            },
            {
                'long-center+long-center':'12',
                'long-center+long-end1':'12',
                'long-center+long-end2':'12',
                'long-end1+long-center':'12',
                'long-end1+long-end1':'12',
                'long-end1+long-end2':'12',
                'long-end2+long-center':'12',
                'long-end2+long-end1':'12',
                'long-end2+long-end2':'12',
                'long-center+short-end1':'8',
                'long-center+short-end2':'8',
                'long-end1+short-end1':'8',
                'long-end2+short-end2':'8',
                'short-end1+long-center':'8',
                'short-end2+long-center':'8',
                'short-end1+long-end1':'8',
                'short-end2+long-end2':'8',
                'long-end2+short-end1':'8',
                'long-end1+short-end2':'8',
                'short-end2+long-end1':'8',
                'short-end1+long-end2':'8',
            },
            {},
            {}
        ]
    ,'PTH-48.32': [
            {
                'short-center':'12',
                'short-end':'12',
                'long-center':'16',
                'long-end':'12',
            },
            {
                'long-center+long-center':'16',
                'long-center+long-end1':'16',
                'long-center+long-end2':'16',
                'long-end1+long-center':'16',
                'long-end1+long-end1':'16',
                'long-end1+long-end2':'16',
                'long-end2+long-center':'16',
                'long-end2+long-end1':'16',
                'long-end2+long-end2':'16',
                'long-center+short-end1':'12',
                'long-center+short-end2':'12',
                'long-end1+short-end1':'12',
                'long-end2+short-end2':'12',
                'short-end1+long-center':'12',
                'short-end2+long-center':'12',
                'short-end1+long-end1':'12',
                'short-end2+long-end2':'12',
                'long-end2+short-end1':'12',
                'long-end1+short-end2':'12',
                'short-end2+long-end1':'12',
                'short-end1+long-end2':'12',
            },
            {},
            {}
        ]
    ,'PTH-48.44': [
            {
                'short-center':'16',
                'short-end':'16',
                'long-center':'20',
                'long-end':'16',
            },
            {
                'long-center+long-center':'20',
                'long-center+long-end1':'20',
                'long-center+long-end2':'20',
                'long-end1+long-center':'20',
                'long-end1+long-end1':'20',
                'long-end1+long-end2':'20',
                'long-end2+long-center':'20',
                'long-end2+long-end1':'20',
                'long-end2+long-end2':'20',
                'long-center+short-end1':'16',
                'long-center+short-end2':'16',
                'long-end1+short-end1':'16',
                'long-end2+short-end2':'16',
                'short-end1+long-center':'16',
                'short-end2+long-center':'16',
                'short-end1+long-end1':'16',
                'short-end2+long-end2':'16',
                'long-end2+short-end1':'16',
                'long-end1+short-end2':'16',
                'short-end2+long-end1':'16',
                'short-end1+long-end2':'16',
            },
            {},
            {}
        ]
    ,'PTH-48.50': [
            {
                'short-center':'24',
                'short-end':'20',
                'long-center':'20',
                'long-end':'20',
            },
            {
                'long-center+long-center':'16',
                'long-center+long-end1':'16',
                'long-center+long-end2':'16',
                'long-end1+long-center':'16',
                'long-end1+long-end1':'16',
                'long-end1+long-end2':'16',
                'long-end2+long-center':'16',
                'long-end2+long-end1':'16',
                'long-end2+long-end2':'16',
                'long-center+short-end1':'20',
                'long-center+short-end2':'20',
                'long-end1+short-end1':'20',
                'long-end2+short-end2':'20',
                'short-end1+long-center':'20',
                'short-end2+long-center':'20',
                'short-end1+long-end1':'20',
                'short-end2+long-end2':'20',
                'long-end2+short-end1':'20',
                'long-end1+short-end2':'20',
                'short-end2+long-end1':'20',
                'short-end1+long-end2':'20',
            },
            {},
            {}
        ]
    ,'PTH-48.56': [
            {
                'short-center':'28',
                'short-end':'24',
                'long-center':'24',
                'long-end':'24',
            },
            {
                'long-center+long-center':'20',
                'long-center+long-end1':'20',
                'long-center+long-end2':'20',
                'long-end1+long-center':'20',
                'long-end1+long-end1':'20',
                'long-end1+long-end2':'20',
                'long-end2+long-center':'20',
                'long-end2+long-end1':'20',
                'long-end2+long-end2':'20',
                'long-center+short-end1':'20',
                'long-center+short-end2':'20',
                'long-end1+short-end1':'20',
                'long-end2+short-end2':'20',
                'short-end1+long-center':'20',
                'short-end2+long-center':'20',
                'short-end1+long-end1':'20',
                'short-end2+long-end2':'20',
                'long-end2+short-end1':'20',
                'long-end1+short-end2':'20',
                'short-end2+long-end1':'20',
                'short-end1+long-end2':'20',
            },
            {},
            {}
        ]
    ,'PTH-48.68': [
            {
                'short-center':'32',
                'short-end':'28',
                'long-center':'28',
                'long-end':'28',
            },
            {
                'long-center+long-center':'24',
                'long-center+long-end1':'24',
                'long-center+long-end2':'24',
                'long-end1+long-center':'24',
                'long-end1+long-end1':'24',
                'long-end1+long-end2':'24',
                'long-end2+long-center':'24',
                'long-end2+long-end1':'24',
                'long-end2+long-end2':'24',
                'long-center+short-end1':'24',
                'long-center+short-end2':'24',
                'long-end1+short-end1':'24',
                'long-end2+short-end2':'24',
                'short-end1+long-center':'24',
                'short-end2+long-center':'24',
                'short-end1+long-end1':'24',
                'short-end2+long-end2':'24',
                'long-end2+short-end1':'24',
                'long-end1+short-end2':'24',
                'short-end2+long-end1':'24',
                'short-end1+long-end2':'24',
            },
            {},
            {}
        ]
    ,'PTH-48.74': [
            {
                'short-center':'36',
                'short-end':'32',
                'long-center':'32',
                'long-end':'32',
            },
            {
                'long-center+long-center':'28',
                'long-center+long-end1':'28',
                'long-center+long-end2':'28',
                'long-end1+long-center':'28',
                'long-end1+long-end1':'28',
                'long-end1+long-end2':'28',
                'long-end2+long-center':'28',
                'long-end2+long-end1':'28',
                'long-end2+long-end2':'28',
                'long-center+short-end1':'28',
                'long-center+short-end2':'28',
                'long-end1+short-end1':'28',
                'long-end2+short-end2':'28',
                'short-end1+long-center':'28',
                'short-end2+long-center':'28',
                'short-end1+long-end1':'28',
                'short-end2+long-end2':'28',
                'long-end2+short-end1':'28',
                'long-end1+short-end2':'28',
                'short-end2+long-end1':'28',
                'short-end1+long-end2':'28',
            },
            {},
            {}
        ]
    ,'PTH-48.80': [
            {
                'short-center':'40',
                'short-end':'36',
                'long-center':'36',
                'long-end':'36',
            },
            {
                'long-center+long-center':'32',
                'long-center+long-end1':'32',
                'long-center+long-end2':'32',
                'long-end1+long-center':'32',
                'long-end1+long-end1':'32',
                'long-end1+long-end2':'32',
                'long-end2+long-center':'32',
                'long-end2+long-end1':'32',
                'long-end2+long-end2':'32',
                'long-center+short-end1':'32',
                'long-center+short-end2':'32',
                'long-end1+short-end1':'32',
                'long-end2+short-end2':'32',
                'short-end1+long-center':'32',
                'short-end2+long-center':'32',
                'short-end1+long-end1':'32',
                'short-end2+long-end2':'32',
                'long-end2+short-end1':'32',
                'long-end1+short-end2':'32',
                'short-end2+long-end1':'32',
                'short-end1+long-end2':'32',
            },
            {},
            {}
        ]
    ,'PTH-48.92': [
            {
                'short-center':'44',
                'short-end':'40',
                'long-center':'40',
                'long-end':'40',
            },
            {
                'long-center+long-center':'36',
                'long-center+long-end1':'36',
                'long-center+long-end2':'36',
                'long-end1+long-center':'36',
                'long-end1+long-end1':'36',
                'long-end1+long-end2':'36',
                'long-end2+long-center':'36',
                'long-end2+long-end1':'36',
                'long-end2+long-end2':'36',
                'long-center+short-end1':'36',
                'long-center+short-end2':'36',
                'long-end1+short-end1':'36',
                'long-end2+short-end2':'36',
                'short-end1+long-center':'36',
                'short-end2+long-center':'36',
                'short-end1+long-end1':'36',
                'short-end2+long-end2':'36',
                'long-end2+short-end1':'36',
                'long-end1+short-end2':'36',
                'short-end2+long-end1':'36',
                'short-end1+long-end2':'36',
            },
            {},
            {}
        ]
    ,'PTH-48.98': [
            {
                'short-center':'48',
                'short-end':'44',
                'long-center':'44',
                'long-end':'44',
            },
            {
                'long-center+long-center':'40',
                'long-center+long-end1':'40',
                'long-center+long-end2':'40',
                'long-end1+long-center':'40',
                'long-end1+long-end1':'40',
                'long-end1+long-end2':'40',
                'long-end2+long-center':'40',
                'long-end2+long-end1':'40',
                'long-end2+long-end2':'40',
                'long-center+short-end1':'40',
                'long-center+short-end2':'40',
                'long-end1+short-end1':'40',
                'long-end2+short-end2':'40',
                'short-end1+long-center':'40',
                'short-end2+long-center':'40',
                'short-end1+long-end1':'40',
                'short-end2+long-end2':'40',
                'long-end2+short-end1':'40',
                'long-end1+short-end2':'40',
                'short-end2+long-end1':'40',
                'short-end1+long-end2':'40',
            },
            {},
            {}
        ]
    ,'PTH-48.104': [
            {
                'short-center':'52',
                'short-end':'48',
                'long-center':'48',
                'long-end':'48',
            },
            {
                'long-center+long-center':'44',
                'long-center+long-end1':'44',
                'long-center+long-end2':'44',
                'long-end1+long-center':'44',
                'long-end1+long-end1':'44',
                'long-end1+long-end2':'44',
                'long-end2+long-center':'44',
                'long-end2+long-end1':'44',
                'long-end2+long-end2':'44',
                'long-center+short-end1':'44',
                'long-center+short-end2':'44',
                'long-end1+short-end1':'44',
                'long-end2+short-end2':'44',
                'short-end1+long-center':'44',
                'short-end2+long-center':'44',
                'short-end1+long-end1':'44',
                'short-end2+long-end2':'44',
                'long-end2+short-end1':'44',
                'long-end1+short-end2':'44',
                'short-end2+long-end1':'44',
                'short-end1+long-end2':'44',
            },
            {},
            {}
        ]
    ,'PTH-48.116': [
            {
                'short-center':'56',
                'short-end':'52',
                'long-center':'52',
                'long-end':'52',
            },
            {
                'long-center+long-center':'48',
                'long-center+long-end1':'48',
                'long-center+long-end2':'48',
                'long-end1+long-center':'48',
                'long-end1+long-end1':'48',
                'long-end1+long-end2':'48',
                'long-end2+long-center':'48',
                'long-end2+long-end1':'48',
                'long-end2+long-end2':'48',
                'long-center+short-end1':'48',
                'long-center+short-end2':'48',
                'long-end1+short-end1':'48',
                'long-end2+short-end2':'48',
                'short-end1+long-center':'48',
                'short-end2+long-center':'48',
                'short-end1+long-end1':'48',
                'short-end2+long-end2':'48',
                'long-end2+short-end1':'48',
                'long-end1+short-end2':'48',
                'short-end2+long-end1':'48',
                'short-end1+long-end2':'48',
            },
            {},
            {}
        ]
    ,'PTH-48.122': [
            {
                'short-center':'60',
                'short-end':'56',
                'long-center':'56',
                'long-end':'56',
            },
            {
                'long-center+long-center':'52',
                'long-center+long-end1':'52',
                'long-center+long-end2':'52',
                'long-end1+long-center':'52',
                'long-end1+long-end1':'52',
                'long-end1+long-end2':'52',
                'long-end2+long-center':'52',
                'long-end2+long-end1':'52',
                'long-end2+long-end2':'52',
                'long-center+short-end1':'52',
                'long-center+short-end2':'52',
                'long-end1+short-end1':'52',
                'long-end2+short-end2':'52',
                'short-end1+long-center':'52',
                'short-end2+long-center':'52',
                'short-end1+long-end1':'52',
                'short-end2+long-end2':'52',
                'long-end2+short-end1':'52',
                'long-end1+short-end2':'52',
                'short-end2+long-end1':'52',
                'short-end1+long-end2':'52',
            },
            {},
            {}
        ]
    ,'PTH-48.128': [
            {
                'short-center':'64',
                'short-end':'60',
                'long-center':'60',
                'long-end':'60',
            },
            {
                'long-center+long-center':'56',
                'long-center+long-end1':'56',
                'long-center+long-end2':'56',
                'long-end1+long-center':'56',
                'long-end1+long-end1':'56',
                'long-end1+long-end2':'56',
                'long-end2+long-center':'56',
                'long-end2+long-end1':'56',
                'long-end2+long-end2':'56',
                'long-center+short-end1':'56',
                'long-center+short-end2':'56',
                'long-end1+short-end1':'56',
                'long-end2+short-end2':'56',
                'short-end1+long-center':'56',
                'short-end2+long-center':'56',
                'short-end1+long-end1':'56',
                'short-end2+long-end2':'56',
                'long-end2+short-end1':'56',
                'long-end1+short-end2':'56',
                'short-end2+long-end1':'56',
                'short-end1+long-end2':'56',
            },
            {},
            {}
        ]
    ,'PTH-48.140': [
            {
                'short-center':'68',
                'short-end':'64',
                'long-center':'64',
                'long-end':'60',
            },
            {
                'long-center+long-center':'60',
                'long-center+long-end1':'60',
                'long-center+long-end2':'60',
                'long-end1+long-center':'60',
                'long-end1+long-end1':'60',
                'long-end1+long-end2':'60',
                'long-end2+long-center':'60',
                'long-end2+long-end1':'60',
                'long-end2+long-end2':'60',
                'long-center+short-end1':'60',
                'long-center+short-end2':'60',
                'long-end1+short-end1':'60',
                'long-end2+short-end2':'60',
                'short-end1+long-center':'60',
                'short-end2+long-center':'60',
                'short-end1+long-end1':'60',
                'short-end2+long-end2':'60',
                'long-end2+short-end1':'60',
                'long-end1+short-end2':'60',
                'short-end2+long-end1':'60',
                'short-end1+long-end2':'60',
            },
            {},
            {}
        ]
    ,'PTH-48.146': [
            {
                'short-center':'72',
                'short-end':'68',
                'long-center':'68',
                'long-end':'68',
            },
            {
                'long-center+long-center':'64',
                'long-center+long-end1':'64',
                'long-center+long-end2':'64',
                'long-end1+long-center':'64',
                'long-end1+long-end1':'64',
                'long-end1+long-end2':'64',
                'long-end2+long-center':'64',
                'long-end2+long-end1':'64',
                'long-end2+long-end2':'64',
                'long-center+short-end1':'64',
                'long-center+short-end2':'64',
                'long-end1+short-end1':'64',
                'long-end2+short-end2':'64',
                'short-end1+long-center':'64',
                'short-end2+long-center':'64',
                'short-end1+long-end1':'64',
                'short-end2+long-end2':'64',
                'long-end2+short-end1':'64',
                'long-end1+short-end2':'64',
                'short-end2+long-end1':'64',
                'short-end1+long-end2':'64',
            },
            {},
            {}
        ]
    ,'PTH-48.152': [
            {
                'short-center':'76',
                'short-end':'72',
                'long-center':'72',
                'long-end':'72',
            },
            {
                'long-center+long-center':'68',
                'long-center+long-end1':'68',
                'long-center+long-end2':'68',
                'long-end1+long-center':'68',
                'long-end1+long-end1':'68',
                'long-end1+long-end2':'68',
                'long-end2+long-center':'68',
                'long-end2+long-end1':'68',
                'long-end2+long-end2':'68',
                'long-center+short-end1':'68',
                'long-center+short-end2':'68',
                'long-end1+short-end1':'68',
                'long-end2+short-end2':'68',
                'short-end1+long-center':'68',
                'short-end2+long-center':'68',
                'short-end1+long-end1':'68',
                'short-end2+long-end2':'68',
                'long-end2+short-end1':'68',
                'long-end1+short-end2':'68',
                'short-end2+long-end1':'68',
                'short-end1+long-end2':'68',
            },
            {},
            {}
        ]
    },
    'Scooter': {
        'PTH-30.26': [
            {
                'short-center':'2',
                'short-end':'2',
                'long-center':'N/A',
                'long-end':'2',
            },
            {
                'long-center+long-center':'N/A',
                'long-center+long-end1':'N/A',
                'long-center+long-end2':'N/A',
                'long-end1+long-center':'N/A',
                'long-end1+long-end1':'N/A',
                'long-end1+long-end2':'N/A',
                'long-end2+long-center':'N/A',
                'long-end2+long-end1':'N/A',
                'long-end2+long-end2':'N/A',
                'long-center+short-end1':'N/A',
                'long-center+short-end2':'N/A',
                'long-end1+short-end1':'N/A',
                'long-end2+short-end2':'N/A',
                'short-end1+long-center':'N/A',
                'short-end2+long-center':'N/A',
                'short-end1+long-end1':'N/A',
                'short-end2+long-end2':'N/A',
                'long-end2+short-end1':'N/A',
                'long-end1+short-end2':'N/A',
                'short-end2+long-end1':'N/A',
                'short-end1+long-end2':'N/A',
            },
            {},
            {}
        ]
    ,'PTH-30.38': [
            {
                'short-center':'1',
                'short-end':'3',
                'long-center':'3',
                'long-end':'3',
            },
            {
                'long-center+long-center':'2',
                'long-center+long-end1':'2',
                'long-center+long-end2':'2',
                'long-end1+long-center':'2',
                'long-end1+long-end1':'2',
                'long-end1+long-end2':'2',
                'long-end2+long-center':'2',
                'long-end2+long-end1':'2',
                'long-end2+long-end2':'2',
                'long-center+short-end1':'3',
                'long-center+short-end2':'3',
                'long-end1+short-end1':'3',
                'long-end2+short-end2':'3',
                'short-end1+long-center':'3',
                'short-end2+long-center':'3',
                'short-end1+long-end1':'3',
                'short-end2+long-end2':'3',
                'long-end2+short-end1':'3',
                'long-end1+short-end2':'3',
                'short-end2+long-end1':'3',
                'short-end1+long-end2':'3',
            },
            {},
            {}
        ]
    ,'PTH-30.50': [
            {
                'short-center':'2',
                'short-end':'4',
                'long-center':'4',
                'long-end':'4',
            },
            {
                'long-center+long-center':'2',
                'long-center+long-end1':'2',
                'long-center+long-end2':'2',
                'long-end1+long-center':'2',
                'long-end1+long-end1':'2',
                'long-end1+long-end2':'2',
                'long-end2+long-center':'2',
                'long-end2+long-end1':'2',
                'long-end2+long-end2':'2',
                'long-center+short-end1':'4',
                'long-center+short-end2':'4',
                'long-end1+short-end1':'4',
                'long-end2+short-end2':'4',
                'short-end1+long-center':'4',
                'short-end2+long-center':'4',
                'short-end1+long-end1':'4',
                'short-end2+long-end2':'4',
                'long-end2+short-end1':'4',
                'long-end1+short-end2':'4',
                'short-end2+long-end1':'4',
                'short-end1+long-end2':'4',
            },
            {},
            {}
        ]
    ,'PTH-30.62': [
            {
                'short-center':'3',
                'short-end':'5',
                'long-center':'5',
                'long-end':'5',
            },
            {
                'long-center+long-center':'4',
                'long-center+long-end1':'4',
                'long-center+long-end2':'4',
                'long-end1+long-center':'4',
                'long-end1+long-end1':'4',
                'long-end1+long-end2':'4',
                'long-end2+long-center':'4',
                'long-end2+long-end1':'4',
                'long-end2+long-end2':'4',
                'long-center+short-end1':'5',
                'long-center+short-end2':'5',
                'long-end1+short-end1':'5',
                'long-end2+short-end2':'5',
                'short-end1+long-center':'5',
                'short-end2+long-center':'5',
                'short-end1+long-end1':'5',
                'short-end2+long-end2':'5',
                'long-end2+short-end1':'5',
                'long-end1+short-end2':'5',
                'short-end2+long-end1':'5',
                'short-end1+long-end2':'5',
            },
            {},
            {}
        ]
    ,'PTH-30.74': [
            {
                'short-center':'4',
                'short-end':'6',
                'long-center':'6',
                'long-end':'6',
            },
            {
                'long-center+long-center':'5',
                'long-center+long-end1':'5',
                'long-center+long-end2':'5',
                'long-end1+long-center':'5',
                'long-end1+long-end1':'5',
                'long-end1+long-end2':'5',
                'long-end2+long-center':'5',
                'long-end2+long-end1':'5',
                'long-end2+long-end2':'5',
                'long-center+short-end1':'6',
                'long-center+short-end2':'6',
                'long-end1+short-end1':'6',
                'long-end2+short-end2':'6',
                'short-end1+long-center':'6',
                'short-end2+long-center':'6',
                'short-end1+long-end1':'6',
                'short-end2+long-end2':'6',
                'long-end2+short-end1':'6',
                'long-end1+short-end2':'6',
                'short-end2+long-end1':'6',
                'short-end1+long-end2':'6',
            },
            {},
            {}
        ]
    ,'PTH-30.86': [
            {
                'short-center':'5',
                'short-end':'7',
                'long-center':'7',
                'long-end':'7',
            },
            {
                'long-center+long-center':'6',
                'long-center+long-end1':'6',
                'long-center+long-end2':'6',
                'long-end1+long-center':'6',
                'long-end1+long-end1':'6',
                'long-end1+long-end2':'6',
                'long-end2+long-center':'6',
                'long-end2+long-end1':'6',
                'long-end2+long-end2':'6',
                'long-center+short-end1':'7',
                'long-center+short-end2':'7',
                'long-end1+short-end1':'7',
                'long-end2+short-end2':'7',
                'short-end1+long-center':'7',
                'short-end2+long-center':'7',
                'short-end1+long-end1':'7',
                'short-end2+long-end2':'7',
                'long-end2+short-end1':'7',
                'long-end1+short-end2':'7',
                'short-end2+long-end1':'7',
                'short-end1+long-end2':'7',
            },
            {},
            {}
        ]
    ,'PTH-30.98': [
            {
                'short-center':'6',
                'short-end':'8',
                'long-center':'8',
                'long-end':'8',
            },
            {
                'long-center+long-center':'7',
                'long-center+long-end1':'7',
                'long-center+long-end2':'7',
                'long-end1+long-center':'7',
                'long-end1+long-end1':'7',
                'long-end1+long-end2':'7',
                'long-end2+long-center':'7',
                'long-end2+long-end1':'7',
                'long-end2+long-end2':'7',
                'long-center+short-end1':'8',
                'long-center+short-end2':'8',
                'long-end1+short-end1':'8',
                'long-end2+short-end2':'8',
                'short-end1+long-center':'8',
                'short-end2+long-center':'8',
                'short-end1+long-end1':'8',
                'short-end2+long-end2':'8',
                'long-end2+short-end1':'8',
                'long-end1+short-end2':'8',
                'short-end2+long-end1':'8',
                'short-end1+long-end2':'8',
            },
            {},
            {}
        ]
    ,'PTH-30.110': [
            {
                'short-center':'7',
                'short-end':'9',
                'long-center':'9',
                'long-end':'9',
            },
            {
                'long-center+long-center':'8',
                'long-center+long-end1':'8',
                'long-center+long-end2':'8',
                'long-end1+long-center':'8',
                'long-end1+long-end1':'8',
                'long-end1+long-end2':'8',
                'long-end2+long-center':'8',
                'long-end2+long-end1':'8',
                'long-end2+long-end2':'8',
                'long-center+short-end1':'9',
                'long-center+short-end2':'9',
                'long-end1+short-end1':'9',
                'long-end2+short-end2':'9',
                'short-end1+long-center':'9',
                'short-end2+long-center':'9',
                'short-end1+long-end1':'9',
                'short-end2+long-end2':'9',
                'long-end2+short-end1':'9',
                'long-end1+short-end2':'9',
                'short-end2+long-end1':'9',
                'short-end1+long-end2':'9',
            },
            {},
            {}
        ]
    ,'PTH-30.122': [
            {
                'short-center':'8',
                'short-end':'10',
                'long-center':'10',
                'long-end':'10',
            },
            {
                'long-center+long-center':'9',
                'long-center+long-end1':'9',
                'long-center+long-end2':'9',
                'long-end1+long-center':'9',
                'long-end1+long-end1':'9',
                'long-end1+long-end2':'9',
                'long-end2+long-center':'9',
                'long-end2+long-end1':'9',
                'long-end2+long-end2':'9',
                'long-center+short-end1':'10',
                'long-center+short-end2':'10',
                'long-end1+short-end1':'10',
                'long-end2+short-end2':'10',
                'short-end1+long-center':'10',
                'short-end2+long-center':'10',
                'short-end1+long-end1':'10',
                'short-end2+long-end2':'10',
                'long-end2+short-end1':'10',
                'long-end1+short-end2':'10',
                'short-end2+long-end1':'10',
                'short-end1+long-end2':'10',
            },
            {},
            {}
        ]
    ,'PTH-30.134': [
            {
                'short-center':'9',
                'short-end':'11',
                'long-center':'11',
                'long-end':'11',
            },
            {
                'long-center+long-center':'10',
                'long-center+long-end1':'10',
                'long-center+long-end2':'10',
                'long-end1+long-center':'10',
                'long-end1+long-end1':'10',
                'long-end1+long-end2':'10',
                'long-end2+long-center':'10',
                'long-end2+long-end1':'10',
                'long-end2+long-end2':'10',
                'long-center+short-end1':'11',
                'long-center+short-end2':'11',
                'long-end1+short-end1':'11',
                'long-end2+short-end2':'11',
                'short-end1+long-center':'11',
                'short-end2+long-center':'11',
                'short-end1+long-end1':'11',
                'short-end2+long-end2':'11',
                'long-end2+short-end1':'11',
                'long-end1+short-end2':'11',
                'short-end2+long-end1':'11',
                'short-end1+long-end2':'11',
            },
            {},
            {}
        ]
    ,'PTH-30.146': [
            {
                'short-center':'10',
                'short-end':'12',
                'long-center':'12',
                'long-end':'12',
            },
            {
                'long-center+long-center':'11',
                'long-center+long-end1':'11',
                'long-center+long-end2':'11',
                'long-end1+long-center':'11',
                'long-end1+long-end1':'11',
                'long-end1+long-end2':'11',
                'long-end2+long-center':'11',
                'long-end2+long-end1':'11',
                'long-end2+long-end2':'11',
                'long-center+short-end1':'12',
                'long-center+short-end2':'12',
                'long-end1+short-end1':'12',
                'long-end2+short-end2':'12',
                'short-end1+long-center':'12',
                'short-end2+long-center':'12',
                'short-end1+long-end1':'12',
                'short-end2+long-end2':'12',
                'long-end2+short-end1':'12',
                'long-end1+short-end2':'12',
                'short-end2+long-end1':'12',
                'short-end1+long-end2':'12',
            },
            {},
            {}
        ]
    ,'PTH-48.26': [
            {
                'short-center':'2',
                'short-end':'2',
                'long-center':'4',
                'long-end':'2',
            },
            {
                'long-center+long-center':'4',
                'long-center+long-end1':'4',
                'long-center+long-end2':'4',
                'long-end1+long-center':'4',
                'long-end1+long-end1':'4',
                'long-end1+long-end2':'4',
                'long-end2+long-center':'4',
                'long-end2+long-end1':'4',
                'long-end2+long-end2':'4',
                'long-center+short-end1':'2',
                'long-center+short-end2':'2',
                'long-end1+short-end1':'2',
                'long-end2+short-end2':'2',
                'short-end1+long-center':'2',
                'short-end2+long-center':'2',
                'short-end1+long-end1':'2',
                'short-end2+long-end2':'2',
                'long-end2+short-end1':'2',
                'long-end1+short-end2':'2',
                'short-end2+long-end1':'2',
                'short-end1+long-end2':'2',
            },
            {},
            {}
        ]
    ,'PTH-48.38': [
            {
                'short-center':'5',
                'short-end':'5',
                'long-center':'6',
                'long-end':'4',
            },
            {
                'long-center+long-center':'6',
                'long-center+long-end1':'6',
                'long-center+long-end2':'6',
                'long-end1+long-center':'6',
                'long-end1+long-end1':'6',
                'long-end1+long-end2':'6',
                'long-end2+long-center':'6',
                'long-end2+long-end1':'6',
                'long-end2+long-end2':'6',
                'long-center+short-end1':'5',
                'long-center+short-end2':'5',
                'long-end1+short-end1':'5',
                'long-end2+short-end2':'5',
                'short-end1+long-center':'5',
                'short-end2+long-center':'5',
                'short-end1+long-end1':'5',
                'short-end2+long-end2':'5',
                'long-end2+short-end1':'5',
                'long-end1+short-end2':'5',
                'short-end2+long-end1':'5',
                'short-end1+long-end2':'5',
            },
            {},
            {}
        ]
    ,'PTH-48.50': [
            {
                'short-center':'7',
                'short-end':'7',
                'long-center':'8',
                'long-end':'6',
            },
            {
                'long-center+long-center':'8',
                'long-center+long-end1':'8',
                'long-center+long-end2':'8',
                'long-end1+long-center':'8',
                'long-end1+long-end1':'8',
                'long-end1+long-end2':'8',
                'long-end2+long-center':'8',
                'long-end2+long-end1':'8',
                'long-end2+long-end2':'8',
                'long-center+short-end1':'7',
                'long-center+short-end2':'7',
                'long-end1+short-end1':'7',
                'long-end2+short-end2':'7',
                'short-end1+long-center':'7',
                'short-end2+long-center':'7',
                'short-end1+long-end1':'7',
                'short-end2+long-end2':'7',
                'long-end2+short-end1':'7',
                'long-end1+short-end2':'7',
                'short-end2+long-end1':'7',
                'short-end1+long-end2':'7',
            },
            {},
            {}
        ]
    ,'PTH-48.62': [
            {
                'short-center':'10',
                'short-end':'8',
                'long-center':'9',
                'long-end':'9',
            },
            {
                'long-center+long-center':'8',
                'long-center+long-end1':'8',
                'long-center+long-end2':'8',
                'long-end1+long-center':'8',
                'long-end1+long-end1':'8',
                'long-end1+long-end2':'8',
                'long-end2+long-center':'8',
                'long-end2+long-end1':'8',
                'long-end2+long-end2':'8',
                'long-center+short-end1':'7',
                'long-center+short-end2':'7',
                'long-end1+short-end1':'7',
                'long-end2+short-end2':'7',
                'short-end1+long-center':'7',
                'short-end2+long-center':'7',
                'short-end1+long-end1':'7',
                'short-end2+long-end2':'7',
                'long-end2+short-end1':'7',
                'long-end1+short-end2':'7',
                'short-end2+long-end1':'7',
                'short-end1+long-end2':'7',
            },
            {},
            {}
        ]
    ,'PTH-48.74': [
            {
                'short-center':'12',
                'short-end':'10',
                'long-center':'11',
                'long-end':'11',
            },
            {
                'long-center+long-center':'10',
                'long-center+long-end1':'10',
                'long-center+long-end2':'10',
                'long-end1+long-center':'10',
                'long-end1+long-end1':'10',
                'long-end1+long-end2':'10',
                'long-end2+long-center':'10',
                'long-end2+long-end1':'10',
                'long-end2+long-end2':'10',
                'long-center+short-end1':'9',
                'long-center+short-end2':'9',
                'long-end1+short-end1':'9',
                'long-end2+short-end2':'9',
                'short-end1+long-center':'9',
                'short-end2+long-center':'9',
                'short-end1+long-end1':'9',
                'short-end2+long-end2':'9',
                'long-end2+short-end1':'9',
                'long-end1+short-end2':'9',
                'short-end2+long-end1':'9',
                'short-end1+long-end2':'9',
            },
            {},
            {}
        ]
    ,'PTH-48.86': [
            {
                'short-center':'14',
                'short-end':'12',
                'long-center':'13',
                'long-end':'13',
            },
            {
                'long-center+long-center':'12',
                'long-center+long-end1':'12',
                'long-center+long-end2':'12',
                'long-end1+long-center':'12',
                'long-end1+long-end1':'12',
                'long-end1+long-end2':'12',
                'long-end2+long-center':'12',
                'long-end2+long-end1':'12',
                'long-end2+long-end2':'12',
                'long-center+short-end1':'11',
                'long-center+short-end2':'11',
                'long-end1+short-end1':'11',
                'long-end2+short-end2':'11',
                'short-end1+long-center':'11',
                'short-end2+long-center':'11',
                'short-end1+long-end1':'11',
                'short-end2+long-end2':'11',
                'long-end2+short-end1':'11',
                'long-end1+short-end2':'11',
                'short-end2+long-end1':'11',
                'short-end1+long-end2':'11',
            },
            {},
            {}
        ]
    ,'PTH-48.98': [
            {
                'short-center':'16',
                'short-end':'14',
                'long-center':'15',
                'long-end':'15',
            },
            {
                'long-center+long-center':'14',
                'long-center+long-end1':'14',
                'long-center+long-end2':'14',
                'long-end1+long-center':'14',
                'long-end1+long-end1':'14',
                'long-end1+long-end2':'14',
                'long-end2+long-center':'14',
                'long-end2+long-end1':'14',
                'long-end2+long-end2':'14',
                'long-center+short-end1':'13',
                'long-center+short-end2':'13',
                'long-end1+short-end1':'13',
                'long-end2+short-end2':'13',
                'short-end1+long-center':'13',
                'short-end2+long-center':'13',
                'short-end1+long-end1':'13',
                'short-end2+long-end2':'13',
                'long-end2+short-end1':'13',
                'long-end1+short-end2':'13',
                'short-end2+long-end1':'13',
                'short-end1+long-end2':'13',
            },
            {},
            {}
        ]
    ,'PTH-48.110': [
            {
                'short-center':'18',
                'short-end':'16',
                'long-center':'17',
                'long-end':'17',
            },
            {
                'long-center+long-center':'16',
                'long-center+long-end1':'16',
                'long-center+long-end2':'16',
                'long-end1+long-center':'16',
                'long-end1+long-end1':'16',
                'long-end1+long-end2':'16',
                'long-end2+long-center':'16',
                'long-end2+long-end1':'16',
                'long-end2+long-end2':'16',
                'long-center+short-end1':'15',
                'long-center+short-end2':'15',
                'long-end1+short-end1':'15',
                'long-end2+short-end2':'15',
                'short-end1+long-center':'15',
                'short-end2+long-center':'15',
                'short-end1+long-end1':'15',
                'short-end2+long-end2':'15',
                'long-end2+short-end1':'15',
                'long-end1+short-end2':'15',
                'short-end2+long-end1':'15',
                'short-end1+long-end2':'15',
            },
            {},
            {}
        ]
    ,'PTH-48.122': [
            {
                'short-center':'20',
                'short-end':'18',
                'long-center':'19',
                'long-end':'19',
            },
            {
                'long-center+long-center':'18',
                'long-center+long-end1':'18',
                'long-center+long-end2':'18',
                'long-end1+long-center':'18',
                'long-end1+long-end1':'18',
                'long-end1+long-end2':'18',
                'long-end2+long-center':'18',
                'long-end2+long-end1':'18',
                'long-end2+long-end2':'18',
                'long-center+short-end1':'17',
                'long-center+short-end2':'17',
                'long-end1+short-end1':'17',
                'long-end2+short-end2':'17',
                'short-end1+long-center':'17',
                'short-end2+long-center':'17',
                'short-end1+long-end1':'17',
                'short-end2+long-end2':'17',
                'long-end2+short-end1':'17',
                'long-end1+short-end2':'17',
                'short-end2+long-end1':'17',
                'short-end1+long-end2':'17',
            },
            {},
            {}
        ]
    ,'PTH-48.134': [
            {
                'short-center':'22',
                'short-end':'20',
                'long-center':'21',
                'long-end':'21',
            },
            {
                'long-center+long-center':'20',
                'long-center+long-end1':'20',
                'long-center+long-end2':'20',
                'long-end1+long-center':'20',
                'long-end1+long-end1':'20',
                'long-end1+long-end2':'20',
                'long-end2+long-center':'20',
                'long-end2+long-end1':'20',
                'long-end2+long-end2':'20',
                'long-center+short-end1':'19',
                'long-center+short-end2':'19',
                'long-end1+short-end1':'19',
                'long-end2+short-end2':'19',
                'short-end1+long-center':'19',
                'short-end2+long-center':'19',
                'short-end1+long-end1':'19',
                'short-end2+long-end2':'19',
                'long-end2+short-end1':'19',
                'long-end1+short-end2':'19',
                'short-end2+long-end1':'19',
                'short-end1+long-end2':'19',
            },
            {},
            {}
        ]
    ,'PTH-48.146': [
            {
                'short-center':'24',
                'short-end':'22',
                'long-center':'23',
                'long-end':'23',
            },
            {
                'long-center+long-center':'22',
                'long-center+long-end1':'22',
                'long-center+long-end2':'22',
                'long-end1+long-center':'22',
                'long-end1+long-end1':'22',
                'long-end1+long-end2':'22',
                'long-end2+long-center':'22',
                'long-end2+long-end1':'22',
                'long-end2+long-end2':'22',
                'long-center+short-end1':'21',
                'long-center+short-end2':'21',
                'long-end1+short-end1':'21',
                'long-end2+short-end2':'21',
                'short-end1+long-center':'21',
                'short-end2+long-center':'21',
                'short-end1+long-end1':'21',
                'short-end2+long-end2':'21',
                'long-end2+short-end1':'21',
                'long-end1+short-end2':'21',
                'short-end2+long-end1':'21',
                'short-end1+long-end2':'21',
            },
            {},
            {}
        ]
    },
    'SV': {
        'PTH-24.26': [
            {
                'short-center':'N/A',
                'short-end':'6',
                'long-center':'6',
                'long-end':'4',
            },
            {
                'long-center+long-center':'2',
                'long-center+long-end1':'2',
                'long-center+long-end2':'2',
                'long-end1+long-center':'2',
                'long-end1+long-end1':'2',
                'long-end1+long-end2':'2',
                'long-end2+long-center':'2',
                'long-end2+long-end1':'2',
                'long-end2+long-end2':'2',
                'long-center+short-end1':'2',
                'long-center+short-end2':'2',
                'long-end1+short-end1':'2',
                'long-end2+short-end2':'2',
                'short-end1+long-center':'2',
                'short-end2+long-center':'2',
                'short-end1+long-end1':'2',
                'short-end2+long-end2':'2',
                'long-end2+short-end1':'2',
                'long-end1+short-end2':'2',
                'short-end2+long-end1':'2',
                'short-end1+long-end2':'2',
            },
            {},
            {}
        ]
    ,'PTH-24.32': [
            {
                'short-center':'2',
                'short-end':'8',
                'long-center':'8',
                'long-end':'6',
            },
            {
                'long-center+long-center':'4',
                'long-center+long-end1':'4',
                'long-center+long-end2':'4',
                'long-end1+long-center':'4',
                'long-end1+long-end1':'4',
                'long-end1+long-end2':'4',
                'long-end2+long-center':'4',
                'long-end2+long-end1':'4',
                'long-end2+long-end2':'4',
                'long-center+short-end1':'4',
                'long-center+short-end2':'4',
                'long-end1+short-end1':'4',
                'long-end2+short-end2':'4',
                'short-end1+long-center':'4',
                'short-end2+long-center':'4',
                'short-end1+long-end1':'4',
                'short-end2+long-end2':'4',
                'long-end2+short-end1':'4',
                'long-end1+short-end2':'4',
                'short-end2+long-end1':'4',
                'short-end1+long-end2':'4',
            },
            {},
            {}
        ]
    ,'PTH-24.44': [
            {
                'short-center':'6',
                'short-end':'12',
                'long-center':'12',
                'long-end':'10',
            },
            {
                'long-center+long-center':'6',
                'long-center+long-end1':'6',
                'long-center+long-end2':'6',
                'long-end1+long-center':'6',
                'long-end1+long-end1':'6',
                'long-end1+long-end2':'6',
                'long-end2+long-center':'6',
                'long-end2+long-end1':'6',
                'long-end2+long-end2':'6',
                'long-center+short-end1':'6',
                'long-center+short-end2':'6',
                'long-end1+short-end1':'6',
                'long-end2+short-end2':'6',
                'short-end1+long-center':'6',
                'short-end2+long-center':'6',
                'short-end1+long-end1':'6',
                'short-end2+long-end2':'6',
                'long-end2+short-end1':'6',
                'long-end1+short-end2':'6',
                'short-end2+long-end1':'6',
                'short-end1+long-end2':'6',
            },
            {},
            {}
        ]
    ,'PTH-24.50': [
            {
                'short-center':'8',
                'short-end':'14',
                'long-center':'14',
                'long-end':'12',
            },
            {
                'long-center+long-center':'8',
                'long-center+long-end1':'8',
                'long-center+long-end2':'8',
                'long-end1+long-center':'8',
                'long-end1+long-end1':'8',
                'long-end1+long-end2':'8',
                'long-end2+long-center':'8',
                'long-end2+long-end1':'8',
                'long-end2+long-end2':'8',
                'long-center+short-end1':'8',
                'long-center+short-end2':'8',
                'long-end1+short-end1':'8',
                'long-end2+short-end2':'8',
                'short-end1+long-center':'8',
                'short-end2+long-center':'8',
                'short-end1+long-end1':'8',
                'short-end2+long-end2':'8',
                'long-end2+short-end1':'8',
                'long-end1+short-end2':'8',
                'short-end2+long-end1':'8',
                'short-end1+long-end2':'8',
            },
            {},
            {}
        ]
    ,'PTH-24.56': [
            {
                'short-center':'10',
                'short-end':'16',
                'long-center':'16',
                'long-end':'14',
            },
            {
                'long-center+long-center':'10',
                'long-center+long-end1':'10',
                'long-center+long-end2':'10',
                'long-end1+long-center':'10',
                'long-end1+long-end1':'10',
                'long-end1+long-end2':'10',
                'long-end2+long-center':'10',
                'long-end2+long-end1':'10',
                'long-end2+long-end2':'10',
                'long-center+short-end1':'10',
                'long-center+short-end2':'10',
                'long-end1+short-end1':'10',
                'long-end2+short-end2':'10',
                'short-end1+long-center':'10',
                'short-end2+long-center':'10',
                'short-end1+long-end1':'10',
                'short-end2+long-end2':'10',
                'long-end2+short-end1':'10',
                'long-end1+short-end2':'10',
                'short-end2+long-end1':'10',
                'short-end1+long-end2':'10',
            },
            {},
            {}
        ]
    ,'PTH-24.68': [
            {
                'short-center':'12',
                'short-end':'18',
                'long-center':'18',
                'long-end':'16',
            },
            {
                'long-center+long-center':'N/A',
                'long-center+long-end1':'N/A',
                'long-center+long-end2':'N/A',
                'long-end1+long-center':'N/A',
                'long-end1+long-end1':'N/A',
                'long-end1+long-end2':'N/A',
                'long-end2+long-center':'N/A',
                'long-end2+long-end1':'N/A',
                'long-end2+long-end2':'N/A',
                'long-center+short-end1':'N/A',
                'long-center+short-end2':'N/A',
                'long-end1+short-end1':'N/A',
                'long-end2+short-end2':'N/A',
                'short-end1+long-center':'N/A',
                'short-end2+long-center':'N/A',
                'short-end1+long-end1':'N/A',
                'short-end2+long-end2':'N/A',
                'long-end2+short-end1':'N/A',
                'long-end1+short-end2':'N/A',
                'short-end2+long-end1':'N/A',
                'short-end1+long-end2':'N/A',
            },
            {},
            {}
        ]
    ,'PTH-24.74': [
            {
                'short-center':'14',
                'short-end':'20',
                'long-center':'20',
                'long-end':'18',
            },
            {
                'long-center+long-center':'16',
                'long-center+long-end1':'16',
                'long-center+long-end2':'16',
                'long-end1+long-center':'16',
                'long-end1+long-end1':'16',
                'long-end1+long-end2':'16',
                'long-end2+long-center':'16',
                'long-end2+long-end1':'16',
                'long-end2+long-end2':'16',
                'long-center+short-end1':'16',
                'long-center+short-end2':'16',
                'long-end1+short-end1':'16',
                'long-end2+short-end2':'16',
                'short-end1+long-center':'16',
                'short-end2+long-center':'16',
                'short-end1+long-end1':'16',
                'short-end2+long-end2':'16',
                'long-end2+short-end1':'16',
                'long-end1+short-end2':'16',
                'short-end2+long-end1':'16',
                'short-end1+long-end2':'16',
            },
            {},
            {}
        ]
    ,'PTH-24.80': [
            {
                'short-center':'16',
                'short-end':'22',
                'long-center':'22',
                'long-end':'20',
            },
            {
                'long-center+long-center':'N/A',
                'long-center+long-end1':'N/A',
                'long-center+long-end2':'N/A',
                'long-end1+long-center':'N/A',
                'long-end1+long-end1':'N/A',
                'long-end1+long-end2':'N/A',
                'long-end2+long-center':'N/A',
                'long-end2+long-end1':'N/A',
                'long-end2+long-end2':'N/A',
                'long-center+short-end1':'N/A',
                'long-center+short-end2':'N/A',
                'long-end1+short-end1':'N/A',
                'long-end2+short-end2':'N/A',
                'short-end1+long-center':'N/A',
                'short-end2+long-center':'N/A',
                'short-end1+long-end1':'N/A',
                'short-end2+long-end2':'N/A',
                'long-end2+short-end1':'N/A',
                'long-end1+short-end2':'N/A',
                'short-end2+long-end1':'N/A',
                'short-end1+long-end2':'N/A',
            },
            {},
            {}
        ]
    ,'PTH-24.92': [
            {
                'short-center':'20',
                'short-end':'26',
                'long-center':'26',
                'long-end':'24',
            },
            {
                'long-center+long-center':'22',
                'long-center+long-end1':'22',
                'long-center+long-end2':'22',
                'long-end1+long-center':'22',
                'long-end1+long-end1':'22',
                'long-end1+long-end2':'22',
                'long-end2+long-center':'22',
                'long-end2+long-end1':'22',
                'long-end2+long-end2':'22',
                'long-center+short-end1':'22',
                'long-center+short-end2':'22',
                'long-end1+short-end1':'22',
                'long-end2+short-end2':'22',
                'short-end1+long-center':'22',
                'short-end2+long-center':'22',
                'short-end1+long-end1':'22',
                'short-end2+long-end2':'22',
                'long-end2+short-end1':'22',
                'long-end1+short-end2':'22',
                'short-end2+long-end1':'22',
                'short-end1+long-end2':'22',
            },
            {},
            {}
        ]
    ,'PTH-24.98': [
            {
                'short-center':'22',
                'short-end':'28',
                'long-center':'28',
                'long-end':'26',
            },
            {
                'long-center+long-center':'24',
                'long-center+long-end1':'24',
                'long-center+long-end2':'24',
                'long-end1+long-center':'24',
                'long-end1+long-end1':'24',
                'long-end1+long-end2':'24',
                'long-end2+long-center':'24',
                'long-end2+long-end1':'24',
                'long-end2+long-end2':'24',
                'long-center+short-end1':'24',
                'long-center+short-end2':'24',
                'long-end1+short-end1':'24',
                'long-end2+short-end2':'24',
                'short-end1+long-center':'24',
                'short-end2+long-center':'24',
                'short-end1+long-end1':'24',
                'short-end2+long-end2':'24',
                'long-end2+short-end1':'24',
                'long-end1+short-end2':'24',
                'short-end2+long-end1':'24',
                'short-end1+long-end2':'24',
            },
            {},
            {}
        ]
    ,'PTH-24.104': [
            {
                'short-center':'24',
                'short-end':'30',
                'long-center':'30',
                'long-end':'28',
            },
            {
                'long-center+long-center':'26',
                'long-center+long-end1':'26',
                'long-center+long-end2':'26',
                'long-end1+long-center':'26',
                'long-end1+long-end1':'26',
                'long-end1+long-end2':'26',
                'long-end2+long-center':'26',
                'long-end2+long-end1':'26',
                'long-end2+long-end2':'26',
                'long-center+short-end1':'26',
                'long-center+short-end2':'26',
                'long-end1+short-end1':'26',
                'long-end2+short-end2':'26',
                'short-end1+long-center':'26',
                'short-end2+long-center':'26',
                'short-end1+long-end1':'26',
                'short-end2+long-end2':'26',
                'long-end2+short-end1':'26',
                'long-end1+short-end2':'26',
                'short-end2+long-end1':'26',
                'short-end1+long-end2':'26',
            },
            {},
            {}
        ]
    ,'PTH-24.116': [
            {
                'short-center':'28',
                'short-end':'34',
                'long-center':'34',
                'long-end':'32',
            },
            {
                'long-center+long-center':'30',
                'long-center+long-end1':'30',
                'long-center+long-end2':'30',
                'long-end1+long-center':'30',
                'long-end1+long-end1':'30',
                'long-end1+long-end2':'30',
                'long-end2+long-center':'30',
                'long-end2+long-end1':'30',
                'long-end2+long-end2':'30',
                'long-center+short-end1':'30',
                'long-center+short-end2':'30',
                'long-end1+short-end1':'30',
                'long-end2+short-end2':'30',
                'short-end1+long-center':'30',
                'short-end2+long-center':'30',
                'short-end1+long-end1':'30',
                'short-end2+long-end2':'30',
                'long-end2+short-end1':'30',
                'long-end1+short-end2':'30',
                'short-end2+long-end1':'30',
                'short-end1+long-end2':'30',
            },
            {},
            {}
        ]
    ,'PTH-24.122': [
            {
                'short-center':'30',
                'short-end':'36',
                'long-center':'36',
                'long-end':'34',
            },
            {
                'long-center+long-center':'32',
                'long-center+long-end1':'32',
                'long-center+long-end2':'32',
                'long-end1+long-center':'32',
                'long-end1+long-end1':'32',
                'long-end1+long-end2':'32',
                'long-end2+long-center':'32',
                'long-end2+long-end1':'32',
                'long-end2+long-end2':'32',
                'long-center+short-end1':'32',
                'long-center+short-end2':'32',
                'long-end1+short-end1':'32',
                'long-end2+short-end2':'32',
                'short-end1+long-center':'32',
                'short-end2+long-center':'32',
                'short-end1+long-end1':'32',
                'short-end2+long-end2':'32',
                'long-end2+short-end1':'32',
                'long-end1+short-end2':'32',
                'short-end2+long-end1':'32',
                'short-end1+long-end2':'32',
            },
            {},
            {}
        ]
    ,'PTH-24.128': [
            {
                'short-center':'32',
                'short-end':'38',
                'long-center':'38',
                'long-end':'36',
            },
            {
                'long-center+long-center':'34',
                'long-center+long-end1':'34',
                'long-center+long-end2':'34',
                'long-end1+long-center':'34',
                'long-end1+long-end1':'34',
                'long-end1+long-end2':'34',
                'long-end2+long-center':'34',
                'long-end2+long-end1':'34',
                'long-end2+long-end2':'34',
                'long-center+short-end1':'34',
                'long-center+short-end2':'34',
                'long-end1+short-end1':'34',
                'long-end2+short-end2':'34',
                'short-end1+long-center':'34',
                'short-end2+long-center':'34',
                'short-end1+long-end1':'34',
                'short-end2+long-end2':'34',
                'long-end2+short-end1':'34',
                'long-end1+short-end2':'34',
                'short-end2+long-end1':'34',
                'short-end1+long-end2':'34',
            },
            {},
            {}
        ]
    ,'PTH-24.140': [
            {
                'short-center':'36',
                'short-end':'42',
                'long-center':'42',
                'long-end':'40',
            },
            {
                'long-center+long-center':'38',
                'long-center+long-end1':'38',
                'long-center+long-end2':'38',
                'long-end1+long-center':'38',
                'long-end1+long-end1':'38',
                'long-end1+long-end2':'38',
                'long-end2+long-center':'38',
                'long-end2+long-end1':'38',
                'long-end2+long-end2':'38',
                'long-center+short-end1':'38',
                'long-center+short-end2':'38',
                'long-end1+short-end1':'38',
                'long-end2+short-end2':'38',
                'short-end1+long-center':'38',
                'short-end2+long-center':'38',
                'short-end1+long-end1':'38',
                'short-end2+long-end2':'38',
                'long-end2+short-end1':'38',
                'long-end1+short-end2':'38',
                'short-end2+long-end1':'38',
                'short-end1+long-end2':'38',
            },
            {},
            {}
        ]
    ,'PTH-24.146': [
            {
                'short-center':'38',
                'short-end':'44',
                'long-center':'44',
                'long-end':'42',
            },
            {
                'long-center+long-center':'40',
                'long-center+long-end1':'40',
                'long-center+long-end2':'40',
                'long-end1+long-center':'40',
                'long-end1+long-end1':'40',
                'long-end1+long-end2':'40',
                'long-end2+long-center':'40',
                'long-end2+long-end1':'40',
                'long-end2+long-end2':'40',
                'long-center+short-end1':'40',
                'long-center+short-end2':'40',
                'long-end1+short-end1':'40',
                'long-end2+short-end2':'40',
                'short-end1+long-center':'40',
                'short-end2+long-center':'40',
                'short-end1+long-end1':'40',
                'short-end2+long-end2':'40',
                'long-end2+short-end1':'40',
                'long-end1+short-end2':'40',
                'short-end2+long-end1':'40',
                'short-end1+long-end2':'40',
            },
            {},
            {}
        ]
    ,'PTH-24.152': [
            {
                'short-center':'40',
                'short-end':'46',
                'long-center':'46',
                'long-end':'44',
            },
            {
                'long-center+long-center':'42',
                'long-center+long-end1':'42',
                'long-center+long-end2':'42',
                'long-end1+long-center':'42',
                'long-end1+long-end1':'42',
                'long-end1+long-end2':'42',
                'long-end2+long-center':'42',
                'long-end2+long-end1':'42',
                'long-end2+long-end2':'42',
                'long-center+short-end1':'42',
                'long-center+short-end2':'42',
                'long-end1+short-end1':'42',
                'long-end2+short-end2':'42',
                'short-end1+long-center':'42',
                'short-end2+long-center':'42',
                'short-end1+long-end1':'42',
                'short-end2+long-end2':'42',
                'long-end2+short-end1':'42',
                'long-end1+short-end2':'42',
                'short-end2+long-end1':'42',
                'short-end1+long-end2':'42',
            },
            {},
            {}
        ]
    ,'PTH-48.26': [
            {
                'short-center':'6',
                'short-end':'8',
                'long-center':'12',
                'long-end':'8',
            },
            {
                'long-center+long-center':'12',
                'long-center+long-end1':'12',
                'long-center+long-end2':'12',
                'long-end1+long-center':'12',
                'long-end1+long-end1':'12',
                'long-end1+long-end2':'12',
                'long-end2+long-center':'12',
                'long-end2+long-end1':'12',
                'long-end2+long-end2':'12',
                'long-center+short-end1':'8',
                'long-center+short-end2':'8',
                'long-end1+short-end1':'8',
                'long-end2+short-end2':'8',
                'short-end1+long-center':'8',
                'short-end2+long-center':'8',
                'short-end1+long-end1':'8',
                'short-end2+long-end2':'8',
                'long-end2+short-end1':'8',
                'long-end1+short-end2':'8',
                'short-end2+long-end1':'8',
                'short-end1+long-end2':'8',
            },
            {},
            {}
        ]
    ,'PTH-48.32': [
            {
                'short-center':'12',
                'short-end':'12',
                'long-center':'16',
                'long-end':'12',
            },
            {
                'long-center+long-center':'16',
                'long-center+long-end1':'16',
                'long-center+long-end2':'16',
                'long-end1+long-center':'16',
                'long-end1+long-end1':'16',
                'long-end1+long-end2':'16',
                'long-end2+long-center':'16',
                'long-end2+long-end1':'16',
                'long-end2+long-end2':'16',
                'long-center+short-end1':'12',
                'long-center+short-end2':'12',
                'long-end1+short-end1':'12',
                'long-end2+short-end2':'12',
                'short-end1+long-center':'12',
                'short-end2+long-center':'12',
                'short-end1+long-end1':'12',
                'short-end2+long-end2':'12',
                'long-end2+short-end1':'12',
                'long-end1+short-end2':'12',
                'short-end2+long-end1':'12',
                'short-end1+long-end2':'12',
            },
            {},
            {}
        ]
    ,'PTH-48.44': [
            {
                'short-center':'18',
                'short-end':'18',
                'long-center':'24',
                'long-end':'18',
            },
            {
                'long-center+long-center':'24',
                'long-center+long-end1':'24',
                'long-center+long-end2':'24',
                'long-end1+long-center':'24',
                'long-end1+long-end1':'24',
                'long-end1+long-end2':'24',
                'long-end2+long-center':'24',
                'long-end2+long-end1':'24',
                'long-end2+long-end2':'24',
                'long-center+short-end1':'18',
                'long-center+short-end2':'18',
                'long-end1+short-end1':'18',
                'long-end2+short-end2':'18',
                'short-end1+long-center':'18',
                'short-end2+long-center':'18',
                'short-end1+long-end1':'18',
                'short-end2+long-end2':'18',
                'long-end2+short-end1':'18',
                'long-end1+short-end2':'18',
                'short-end2+long-end1':'18',
                'short-end1+long-end2':'18',
            },
            {},
            {}
        ]
    ,'PTH-48.50': [
            {
                'short-center':'28',
                'short-end':'24',
                'long-center':'24',
                'long-end':'24',
            },
            {
                'long-center+long-center':'20',
                'long-center+long-end1':'20',
                'long-center+long-end2':'20',
                'long-end1+long-center':'20',
                'long-end1+long-end1':'20',
                'long-end1+long-end2':'20',
                'long-end2+long-center':'20',
                'long-end2+long-end1':'20',
                'long-end2+long-end2':'20',
                'long-center+short-end1':'24',
                'long-center+short-end2':'24',
                'long-end1+short-end1':'24',
                'long-end2+short-end2':'24',
                'short-end1+long-center':'24',
                'short-end2+long-center':'24',
                'short-end1+long-end1':'24',
                'short-end2+long-end2':'24',
                'long-end2+short-end1':'24',
                'long-end1+short-end2':'24',
                'short-end2+long-end1':'24',
                'short-end1+long-end2':'24',
            },
            {},
            {}
        ]
    ,'PTH-48.56': [
            {
                'short-center':'32',
                'short-end':'28',
                'long-center':'28',
                'long-end':'28',
            },
            {
                'long-center+long-center':'24',
                'long-center+long-end1':'24',
                'long-center+long-end2':'24',
                'long-end1+long-center':'24',
                'long-end1+long-end1':'24',
                'long-end1+long-end2':'24',
                'long-end2+long-center':'24',
                'long-end2+long-end1':'24',
                'long-end2+long-end2':'24',
                'long-center+short-end1':'24',
                'long-center+short-end2':'24',
                'long-end1+short-end1':'24',
                'long-end2+short-end2':'24',
                'short-end1+long-center':'24',
                'short-end2+long-center':'24',
                'short-end1+long-end1':'24',
                'short-end2+long-end2':'24',
                'long-end2+short-end1':'24',
                'long-end1+short-end2':'24',
                'short-end2+long-end1':'24',
                'short-end1+long-end2':'24',
            },
            {},
            {}
        ]
    ,'PTH-48.68': [
            {
                'short-center':'36',
                'short-end':'32',
                'long-center':'32',
                'long-end':'32',
            },
            {
                'long-center+long-center':'28',
                'long-center+long-end1':'28',
                'long-center+long-end2':'28',
                'long-end1+long-center':'28',
                'long-end1+long-end1':'28',
                'long-end1+long-end2':'28',
                'long-end2+long-center':'28',
                'long-end2+long-end1':'28',
                'long-end2+long-end2':'28',
                'long-center+short-end1':'28',
                'long-center+short-end2':'28',
                'long-end1+short-end1':'28',
                'long-end2+short-end2':'28',
                'short-end1+long-center':'28',
                'short-end2+long-center':'28',
                'short-end1+long-end1':'28',
                'short-end2+long-end2':'28',
                'long-end2+short-end1':'28',
                'long-end1+short-end2':'28',
                'short-end2+long-end1':'28',
                'short-end1+long-end2':'28',
            },
            {},
            {}
        ]
    ,'PTH-48.74': [
            {
                'short-center':'40',
                'short-end':'36',
                'long-center':'36',
                'long-end':'36',
            },
            {
                'long-center+long-center':'32',
                'long-center+long-end1':'32',
                'long-center+long-end2':'32',
                'long-end1+long-center':'32',
                'long-end1+long-end1':'32',
                'long-end1+long-end2':'32',
                'long-end2+long-center':'32',
                'long-end2+long-end1':'32',
                'long-end2+long-end2':'32',
                'long-center+short-end1':'32',
                'long-center+short-end2':'32',
                'long-end1+short-end1':'32',
                'long-end2+short-end2':'32',
                'short-end1+long-center':'32',
                'short-end2+long-center':'32',
                'short-end1+long-end1':'32',
                'short-end2+long-end2':'32',
                'long-end2+short-end1':'32',
                'long-end1+short-end2':'32',
                'short-end2+long-end1':'32',
                'short-end1+long-end2':'32',
            },
            {},
            {}
        ]
    ,'PTH-48.80': [
            {
                'short-center':'44',
                'short-end':'40',
                'long-center':'40',
                'long-end':'40',
            },
            {
                'long-center+long-center':'36',
                'long-center+long-end1':'36',
                'long-center+long-end2':'36',
                'long-end1+long-center':'36',
                'long-end1+long-end1':'36',
                'long-end1+long-end2':'36',
                'long-end2+long-center':'36',
                'long-end2+long-end1':'36',
                'long-end2+long-end2':'36',
                'long-center+short-end1':'36',
                'long-center+short-end2':'36',
                'long-end1+short-end1':'36',
                'long-end2+short-end2':'36',
                'short-end1+long-center':'36',
                'short-end2+long-center':'36',
                'short-end1+long-end1':'36',
                'short-end2+long-end2':'36',
                'long-end2+short-end1':'36',
                'long-end1+short-end2':'36',
                'short-end2+long-end1':'36',
                'short-end1+long-end2':'36',
            },
            {},
            {}
        ]
    ,'PTH-48.92': [
            {
                'short-center':'52',
                'short-end':'48',
                'long-center':'48',
                'long-end':'48',
            },
            {
                'long-center+long-center':'44',
                'long-center+long-end1':'44',
                'long-center+long-end2':'44',
                'long-end1+long-center':'44',
                'long-end1+long-end1':'44',
                'long-end1+long-end2':'44',
                'long-end2+long-center':'44',
                'long-end2+long-end1':'44',
                'long-end2+long-end2':'44',
                'long-center+short-end1':'44',
                'long-center+short-end2':'44',
                'long-end1+short-end1':'44',
                'long-end2+short-end2':'44',
                'short-end1+long-center':'44',
                'short-end2+long-center':'44',
                'short-end1+long-end1':'44',
                'short-end2+long-end2':'44',
                'long-end2+short-end1':'44',
                'long-end1+short-end2':'44',
                'short-end2+long-end1':'44',
                'short-end1+long-end2':'44',
            },
            {},
            {}
        ]
    ,'PTH-48.98': [
            {
                'short-center':'56',
                'short-end':'52',
                'long-center':'52',
                'long-end':'52',
            },
            {
                'long-center+long-center':'48',
                'long-center+long-end1':'48',
                'long-center+long-end2':'48',
                'long-end1+long-center':'48',
                'long-end1+long-end1':'48',
                'long-end1+long-end2':'48',
                'long-end2+long-center':'48',
                'long-end2+long-end1':'48',
                'long-end2+long-end2':'48',
                'long-center+short-end1':'48',
                'long-center+short-end2':'48',
                'long-end1+short-end1':'48',
                'long-end2+short-end2':'48',
                'short-end1+long-center':'48',
                'short-end2+long-center':'48',
                'short-end1+long-end1':'48',
                'short-end2+long-end2':'48',
                'long-end2+short-end1':'48',
                'long-end1+short-end2':'48',
                'short-end2+long-end1':'48',
                'short-end1+long-end2':'48',
            },
            {},
            {}
        ]
    ,'PTH-48.104': [
            {
                'short-center':'60',
                'short-end':'56',
                'long-center':'52',
                'long-end':'52',
            },
            {
                'long-center+long-center':'52',
                'long-center+long-end1':'52',
                'long-center+long-end2':'52',
                'long-end1+long-center':'52',
                'long-end1+long-end1':'52',
                'long-end1+long-end2':'52',
                'long-end2+long-center':'52',
                'long-end2+long-end1':'52',
                'long-end2+long-end2':'52',
                'long-center+short-end1':'52',
                'long-center+short-end2':'52',
                'long-end1+short-end1':'52',
                'long-end2+short-end2':'52',
                'short-end1+long-center':'52',
                'short-end2+long-center':'52',
                'short-end1+long-end1':'52',
                'short-end2+long-end2':'52',
                'long-end2+short-end1':'52',
                'long-end1+short-end2':'52',
                'short-end2+long-end1':'52',
                'short-end1+long-end2':'52',
            },
            {},
            {}
        ]
    ,'PTH-48.116': [
            {
                'short-center':'68',
                'short-end':'64',
                'long-center':'64',
                'long-end':'64',
            },
            {
                'long-center+long-center':'60',
                'long-center+long-end1':'60',
                'long-center+long-end2':'60',
                'long-end1+long-center':'60',
                'long-end1+long-end1':'60',
                'long-end1+long-end2':'60',
                'long-end2+long-center':'60',
                'long-end2+long-end1':'60',
                'long-end2+long-end2':'60',
                'long-center+short-end1':'60',
                'long-center+short-end2':'60',
                'long-end1+short-end1':'60',
                'long-end2+short-end2':'60',
                'short-end1+long-center':'60',
                'short-end2+long-center':'60',
                'short-end1+long-end1':'60',
                'short-end2+long-end2':'60',
                'long-end2+short-end1':'60',
                'long-end1+short-end2':'60',
                'short-end2+long-end1':'60',
                'short-end1+long-end2':'60',
            },
            {},
            {}
        ]
    ,'PTH-48.122': [
            {
                'short-center':'72',
                'short-end':'68',
                'long-center':'68',
                'long-end':'68',
            },
            {
                'long-center+long-center':'64',
                'long-center+long-end1':'64',
                'long-center+long-end2':'64',
                'long-end1+long-center':'64',
                'long-end1+long-end1':'64',
                'long-end1+long-end2':'64',
                'long-end2+long-center':'64',
                'long-end2+long-end1':'64',
                'long-end2+long-end2':'64',
                'long-center+short-end1':'64',
                'long-center+short-end2':'64',
                'long-end1+short-end1':'64',
                'long-end2+short-end2':'64',
                'short-end1+long-center':'64',
                'short-end2+long-center':'64',
                'short-end1+long-end1':'64',
                'short-end2+long-end2':'64',
                'long-end2+short-end1':'64',
                'long-end1+short-end2':'64',
                'short-end2+long-end1':'64',
                'short-end1+long-end2':'64',
            },
            {},
            {}
        ]
    ,'PTH-48.128': [
            {
                'short-center':'72',
                'short-end':'72',
                'long-center':'72',
                'long-end':'72',
            },
            {
                'long-center+long-center':'68',
                'long-center+long-end1':'68',
                'long-center+long-end2':'68',
                'long-end1+long-center':'68',
                'long-end1+long-end1':'68',
                'long-end1+long-end2':'68',
                'long-end2+long-center':'68',
                'long-end2+long-end1':'68',
                'long-end2+long-end2':'68',
                'long-center+short-end1':'68',
                'long-center+short-end2':'68',
                'long-end1+short-end1':'68',
                'long-end2+short-end2':'68',
                'short-end1+long-center':'68',
                'short-end2+long-center':'68',
                'short-end1+long-end1':'68',
                'short-end2+long-end2':'68',
                'long-end2+short-end1':'68',
                'long-end1+short-end2':'68',
                'short-end2+long-end1':'68',
                'short-end1+long-end2':'68',
            },
            {},
            {}
        ]
    ,'PTH-48.140': [
            {
                'short-center':'84',
                'short-end':'80',
                'long-center':'80',
                'long-end':'80',
            },
            {
                'long-center+long-center':'76',
                'long-center+long-end1':'76',
                'long-center+long-end2':'76',
                'long-end1+long-center':'76',
                'long-end1+long-end1':'76',
                'long-end1+long-end2':'76',
                'long-end2+long-center':'76',
                'long-end2+long-end1':'76',
                'long-end2+long-end2':'76',
                'long-center+short-end1':'76',
                'long-center+short-end2':'76',
                'long-end1+short-end1':'76',
                'long-end2+short-end2':'76',
                'short-end1+long-center':'76',
                'short-end2+long-center':'76',
                'short-end1+long-end1':'76',
                'short-end2+long-end2':'76',
                'long-end2+short-end1':'76',
                'long-end1+short-end2':'76',
                'short-end2+long-end1':'76',
                'short-end1+long-end2':'76',
            },
            {},
            {}
        ]
    ,'PTH-48.146': [
            {
                'short-center':'88',
                'short-end':'84',
                'long-center':'84',
                'long-end':'84',
            },
            {
                'long-center+long-center':'80',
                'long-center+long-end1':'80',
                'long-center+long-end2':'80',
                'long-end1+long-center':'80',
                'long-end1+long-end1':'80',
                'long-end1+long-end2':'80',
                'long-end2+long-center':'80',
                'long-end2+long-end1':'80',
                'long-end2+long-end2':'80',
                'long-center+short-end1':'80',
                'long-center+short-end2':'80',
                'long-end1+short-end1':'80',
                'long-end2+short-end2':'80',
                'short-end1+long-center':'80',
                'short-end2+long-center':'80',
                'short-end1+long-end1':'80',
                'short-end2+long-end2':'80',
                'long-end2+short-end1':'80',
                'long-end1+short-end2':'80',
                'short-end2+long-end1':'80',
                'short-end1+long-end2':'80',
            },
            {},
            {}
        ]
    ,'PTH-48.152': [
            {
                'short-center':'92',
                'short-end':'88',
                'long-center':'88',
                'long-end':'88',
            },
            {
                'long-center+long-center':'84',
                'long-center+long-end1':'84',
                'long-center+long-end2':'84',
                'long-end1+long-center':'84',
                'long-end1+long-end1':'84',
                'long-end1+long-end2':'84',
                'long-end2+long-center':'84',
                'long-end2+long-end1':'84',
                'long-end2+long-end2':'84',
                'long-center+short-end1':'84',
                'long-center+short-end2':'84',
                'long-end1+short-end1':'84',
                'long-end2+short-end2':'84',
                'short-end1+long-center':'84',
                'short-end2+long-center':'84',
                'short-end1+long-end1':'84',
                'short-end2+long-end2':'84',
                'long-end2+short-end1':'84',
                'long-end1+short-end2':'84',
                'short-end2+long-end1':'84',
                'short-end1+long-end2':'84',
            },
            {},
            {}
        ]
    },
    'Tall': {
        'PTH-42.26': [
            {
                'short-center':'10',
                'short-end':'10',
                'long-center':'N/A',
                'long-end':'10',
            },
            {
                'long-center+long-center':'10',
                'long-center+long-end1':'10',
                'long-center+long-end2':'10',
                'long-end1+long-center':'10',
                'long-end1+long-end1':'10',
                'long-end1+long-end2':'10',
                'long-end2+long-center':'10',
                'long-end2+long-end1':'10',
                'long-end2+long-end2':'10',
                'long-center+short-end1':'10',
                'long-center+short-end2':'10',
                'long-end1+short-end1':'10',
                'long-end2+short-end2':'10',
                'short-end1+long-center':'10',
                'short-end2+long-center':'10',
                'short-end1+long-end1':'10',
                'short-end2+long-end2':'10',
                'long-end2+short-end1':'10',
                'long-end1+short-end2':'10',
                'short-end2+long-end1':'10',
                'short-end1+long-end2':'10',
            },
            {},
            {}
        ]
    ,'PTH-42.32': [
            {
                'short-center':'14',
                'short-end':'14',
                'long-center':'6',
                'long-end':'14',
            },
            {
                'long-center+long-center':'14',
                'long-center+long-end1':'14',
                'long-center+long-end2':'14',
                'long-end1+long-center':'14',
                'long-end1+long-end1':'14',
                'long-end1+long-end2':'14',
                'long-end2+long-center':'14',
                'long-end2+long-end1':'14',
                'long-end2+long-end2':'14',
                'long-center+short-end1':'14',
                'long-center+short-end2':'14',
                'long-end1+short-end1':'14',
                'long-end2+short-end2':'14',
                'short-end1+long-center':'14',
                'short-end2+long-center':'14',
                'short-end1+long-end1':'14',
                'short-end2+long-end2':'14',
                'long-end2+short-end1':'14',
                'long-end1+short-end2':'14',
                'short-end2+long-end1':'14',
                'short-end1+long-end2':'14',
            },
            {},
            {}
        ]
    ,'PTH-42.38': [
            {
                'short-center':'16',
                'short-end':'16',
                'long-center':'8',
                'long-end':'16',
            },
            {
                'long-center+long-center':'16',
                'long-center+long-end1':'16',
                'long-center+long-end2':'16',
                'long-end1+long-center':'16',
                'long-end1+long-end1':'16',
                'long-end1+long-end2':'16',
                'long-end2+long-center':'16',
                'long-end2+long-end1':'16',
                'long-end2+long-end2':'16',
                'long-center+short-end1':'16',
                'long-center+short-end2':'16',
                'long-end1+short-end1':'16',
                'long-end2+short-end2':'16',
                'short-end1+long-center':'16',
                'short-end2+long-center':'16',
                'short-end1+long-end1':'16',
                'short-end2+long-end2':'16',
                'long-end2+short-end1':'16',
                'long-end1+short-end2':'16',
                'short-end2+long-end1':'16',
                'short-end1+long-end2':'16',
            },
            {},
            {}
        ]
    ,'PTH-42.44': [
            {
                'short-center':'18',
                'short-end':'18',
                'long-center':'10',
                'long-end':'18',
            },
            {
                'long-center+long-center':'18',
                'long-center+long-end1':'18',
                'long-center+long-end2':'18',
                'long-end1+long-center':'18',
                'long-end1+long-end1':'18',
                'long-end1+long-end2':'18',
                'long-end2+long-center':'18',
                'long-end2+long-end1':'18',
                'long-end2+long-end2':'18',
                'long-center+short-end1':'18',
                'long-center+short-end2':'18',
                'long-end1+short-end1':'18',
                'long-end2+short-end2':'18',
                'short-end1+long-center':'18',
                'short-end2+long-center':'18',
                'short-end1+long-end1':'18',
                'short-end2+long-end2':'18',
                'long-end2+short-end1':'18',
                'long-end1+short-end2':'18',
                'short-end2+long-end1':'18',
                'short-end1+long-end2':'18',
            },
            {},
            {}
        ]
    ,'PTH-42.50': [
            {
                'short-center':'14',
                'short-end':'22',
                'long-center':'22',
                'long-end':'22',
            },
            {
                'long-center+long-center':'14',
                'long-center+long-end1':'14',
                'long-center+long-end2':'14',
                'long-end1+long-center':'14',
                'long-end1+long-end1':'14',
                'long-end1+long-end2':'14',
                'long-end2+long-center':'14',
                'long-end2+long-end1':'14',
                'long-end2+long-end2':'14',
                'long-center+short-end1':'22',
                'long-center+short-end2':'22',
                'long-end1+short-end1':'22',
                'long-end2+short-end2':'22',
                'short-end1+long-center':'22',
                'short-end2+long-center':'22',
                'short-end1+long-end1':'22',
                'short-end2+long-end2':'22',
                'long-end2+short-end1':'22',
                'long-end1+short-end2':'22',
                'short-end2+long-end1':'22',
                'short-end1+long-end2':'22',
            },
            {},
            {}
        ]
    ,'PTH-42.56': [
            {
                'short-center':'18',
                'short-end':'26',
                'long-center':'26',
                'long-end':'26',
            },
            {
                'long-center+long-center':'18',
                'long-center+long-end1':'18',
                'long-center+long-end2':'18',
                'long-end1+long-center':'18',
                'long-end1+long-end1':'18',
                'long-end1+long-end2':'18',
                'long-end2+long-center':'18',
                'long-end2+long-end1':'18',
                'long-end2+long-end2':'18',
                'long-center+short-end1':'26',
                'long-center+short-end2':'26',
                'long-end1+short-end1':'26',
                'long-end2+short-end2':'26',
                'short-end1+long-center':'26',
                'short-end2+long-center':'26',
                'short-end1+long-end1':'26',
                'short-end2+long-end2':'26',
                'long-end2+short-end1':'26',
                'long-end1+short-end2':'26',
                'short-end2+long-end1':'26',
                'short-end1+long-end2':'26',
            },
            {},
            {}
        ]
    ,'PTH-42.62': [
            {
                'short-center':'20',
                'short-end':'28',
                'long-center':'28',
                'long-end':'28',
            },
            {
                'long-center+long-center':'20',
                'long-center+long-end1':'20',
                'long-center+long-end2':'20',
                'long-end1+long-center':'20',
                'long-end1+long-end1':'20',
                'long-end1+long-end2':'20',
                'long-end2+long-center':'20',
                'long-end2+long-end1':'20',
                'long-end2+long-end2':'20',
                'long-center+short-end1':'28',
                'long-center+short-end2':'28',
                'long-end1+short-end1':'28',
                'long-end2+short-end2':'28',
                'short-end1+long-center':'28',
                'short-end2+long-center':'28',
                'short-end1+long-end1':'28',
                'short-end2+long-end2':'28',
                'long-end2+short-end1':'28',
                'long-end1+short-end2':'28',
                'short-end2+long-end1':'28',
                'short-end1+long-end2':'28',
            },
            {},
            {}
        ]
    ,'PTH-42.68': [
            {
                'short-center':'24',
                'short-end':'32',
                'long-center':'32',
                'long-end':'32',
            },
            {
                'long-center+long-center':'24',
                'long-center+long-end1':'24',
                'long-center+long-end2':'24',
                'long-end1+long-center':'24',
                'long-end1+long-end1':'24',
                'long-end1+long-end2':'24',
                'long-end2+long-center':'24',
                'long-end2+long-end1':'24',
                'long-end2+long-end2':'24',
                'long-center+short-end1':'32',
                'long-center+short-end2':'32',
                'long-end1+short-end1':'32',
                'long-end2+short-end2':'32',
                'short-end1+long-center':'32',
                'short-end2+long-center':'32',
                'short-end1+long-end1':'32',
                'short-end2+long-end2':'32',
                'long-end2+short-end1':'32',
                'long-end1+short-end2':'32',
                'short-end2+long-end1':'32',
                'short-end1+long-end2':'32',
            },
            {},
            {}
        ]
    ,'PTH-42.74': [
            {
                'short-center':'26',
                'short-end':'34',
                'long-center':'34',
                'long-end':'34',
            },
            {
                'long-center+long-center':'26',
                'long-center+long-end1':'26',
                'long-center+long-end2':'26',
                'long-end1+long-center':'26',
                'long-end1+long-end1':'26',
                'long-end1+long-end2':'26',
                'long-end2+long-center':'26',
                'long-end2+long-end1':'26',
                'long-end2+long-end2':'26',
                'long-center+short-end1':'34',
                'long-center+short-end2':'34',
                'long-end1+short-end1':'34',
                'long-end2+short-end2':'34',
                'short-end1+long-center':'34',
                'short-end2+long-center':'34',
                'short-end1+long-end1':'34',
                'short-end2+long-end2':'34',
                'long-end2+short-end1':'34',
                'long-end1+short-end2':'34',
                'short-end2+long-end1':'34',
                'short-end1+long-end2':'34',
            },
            {},
            {}
        ]
    ,'PTH-42.80': [
            {
                'short-center':'28',
                'short-end':'36',
                'long-center':'36',
                'long-end':'36',
            },
            {
                'long-center+long-center':'28',
                'long-center+long-end1':'28',
                'long-center+long-end2':'28',
                'long-end1+long-center':'28',
                'long-end1+long-end1':'28',
                'long-end1+long-end2':'28',
                'long-end2+long-center':'28',
                'long-end2+long-end1':'28',
                'long-end2+long-end2':'28',
                'long-center+short-end1':'36',
                'long-center+short-end2':'36',
                'long-end1+short-end1':'36',
                'long-end2+short-end2':'36',
                'short-end1+long-center':'36',
                'short-end2+long-center':'36',
                'short-end1+long-end1':'36',
                'short-end2+long-end2':'36',
                'long-end2+short-end1':'36',
                'long-end1+short-end2':'36',
                'short-end2+long-end1':'36',
                'short-end1+long-end2':'36',
            },
            {},
            {}
        ]
    ,'PTH-42.86': [
            {
                'short-center':'32',
                'short-end':'40',
                'long-center':'40',
                'long-end':'40',
            },
            {
                'long-center+long-center':'32',
                'long-center+long-end1':'32',
                'long-center+long-end2':'32',
                'long-end1+long-center':'32',
                'long-end1+long-end1':'32',
                'long-end1+long-end2':'32',
                'long-end2+long-center':'32',
                'long-end2+long-end1':'32',
                'long-end2+long-end2':'32',
                'long-center+short-end1':'40',
                'long-center+short-end2':'40',
                'long-end1+short-end1':'40',
                'long-end2+short-end2':'40',
                'short-end1+long-center':'40',
                'short-end2+long-center':'40',
                'short-end1+long-end1':'40',
                'short-end2+long-end2':'40',
                'long-end2+short-end1':'40',
                'long-end1+short-end2':'40',
                'short-end2+long-end1':'40',
                'short-end1+long-end2':'40',
            },
            {},
            {}
        ]
    ,'PTH-42.92': [
            {
                'short-center':'36',
                'short-end':'44',
                'long-center':'44',
                'long-end':'44',
            },
            {
                'long-center+long-center':'36',
                'long-center+long-end1':'36',
                'long-center+long-end2':'36',
                'long-end1+long-center':'36',
                'long-end1+long-end1':'36',
                'long-end1+long-end2':'36',
                'long-end2+long-center':'36',
                'long-end2+long-end1':'36',
                'long-end2+long-end2':'36',
                'long-center+short-end1':'44',
                'long-center+short-end2':'44',
                'long-end1+short-end1':'44',
                'long-end2+short-end2':'44',
                'short-end1+long-center':'44',
                'short-end2+long-center':'44',
                'short-end1+long-end1':'44',
                'short-end2+long-end2':'44',
                'long-end2+short-end1':'44',
                'long-end1+short-end2':'44',
                'short-end2+long-end1':'44',
                'short-end1+long-end2':'44',
            },
            {},
            {}
        ]
    ,'PTH-42.98': [
            {
                'short-center':'38',
                'short-end':'46',
                'long-center':'46',
                'long-end':'46',
            },
            {
                'long-center+long-center':'38',
                'long-center+long-end1':'38',
                'long-center+long-end2':'38',
                'long-end1+long-center':'38',
                'long-end1+long-end1':'38',
                'long-end1+long-end2':'38',
                'long-end2+long-center':'38',
                'long-end2+long-end1':'38',
                'long-end2+long-end2':'38',
                'long-center+short-end1':'46',
                'long-center+short-end2':'46',
                'long-end1+short-end1':'46',
                'long-end2+short-end2':'46',
                'short-end1+long-center':'46',
                'short-end2+long-center':'46',
                'short-end1+long-end1':'46',
                'short-end2+long-end2':'46',
                'long-end2+short-end1':'46',
                'long-end1+short-end2':'46',
                'short-end2+long-end1':'46',
                'short-end1+long-end2':'46',
            },
            {},
            {}
        ]
    ,'PTH-42.104': [
            {
                'short-center':'40',
                'short-end':'48',
                'long-center':'48',
                'long-end':'48',
            },
            {
                'long-center+long-center':'40',
                'long-center+long-end1':'40',
                'long-center+long-end2':'40',
                'long-end1+long-center':'40',
                'long-end1+long-end1':'40',
                'long-end1+long-end2':'40',
                'long-end2+long-center':'40',
                'long-end2+long-end1':'40',
                'long-end2+long-end2':'40',
                'long-center+short-end1':'48',
                'long-center+short-end2':'48',
                'long-end1+short-end1':'48',
                'long-end2+short-end2':'48',
                'short-end1+long-center':'48',
                'short-end2+long-center':'48',
                'short-end1+long-end1':'48',
                'short-end2+long-end2':'48',
                'long-end2+short-end1':'48',
                'long-end1+short-end2':'48',
                'short-end2+long-end1':'48',
                'short-end1+long-end2':'48',
            },
            {},
            {}
        ]
    ,'PTH-42.110': [
            {
                'short-center':'42',
                'short-end':'50',
                'long-center':'50',
                'long-end':'50',
            },
            {
                'long-center+long-center':'42',
                'long-center+long-end1':'42',
                'long-center+long-end2':'42',
                'long-end1+long-center':'42',
                'long-end1+long-end1':'42',
                'long-end1+long-end2':'42',
                'long-end2+long-center':'42',
                'long-end2+long-end1':'42',
                'long-end2+long-end2':'42',
                'long-center+short-end1':'50',
                'long-center+short-end2':'50',
                'long-end1+short-end1':'50',
                'long-end2+short-end2':'50',
                'short-end1+long-center':'50',
                'short-end2+long-center':'50',
                'short-end1+long-end1':'50',
                'short-end2+long-end2':'50',
                'long-end2+short-end1':'50',
                'long-end1+short-end2':'50',
                'short-end2+long-end1':'50',
                'short-end1+long-end2':'50',
            },
            {},
            {}
        ]
    ,'PTH-42.116': [
            {
                'short-center':'46',
                'short-end':'54',
                'long-center':'54',
                'long-end':'54',
            },
            {
                'long-center+long-center':'46',
                'long-center+long-end1':'46',
                'long-center+long-end2':'46',
                'long-end1+long-center':'46',
                'long-end1+long-end1':'46',
                'long-end1+long-end2':'46',
                'long-end2+long-center':'46',
                'long-end2+long-end1':'46',
                'long-end2+long-end2':'46',
                'long-center+short-end1':'54',
                'long-center+short-end2':'54',
                'long-end1+short-end1':'54',
                'long-end2+short-end2':'54',
                'short-end1+long-center':'54',
                'short-end2+long-center':'54',
                'short-end1+long-end1':'54',
                'short-end2+long-end2':'54',
                'long-end2+short-end1':'54',
                'long-end1+short-end2':'54',
                'short-end2+long-end1':'54',
                'short-end1+long-end2':'54',
            },
            {},
            {}
        ]
    ,'PTH-42.122': [
            {
                'short-center':'48',
                'short-end':'56',
                'long-center':'56',
                'long-end':'56',
            },
            {
                'long-center+long-center':'48',
                'long-center+long-end1':'48',
                'long-center+long-end2':'48',
                'long-end1+long-center':'48',
                'long-end1+long-end1':'48',
                'long-end1+long-end2':'48',
                'long-end2+long-center':'48',
                'long-end2+long-end1':'48',
                'long-end2+long-end2':'48',
                'long-center+short-end1':'56',
                'long-center+short-end2':'56',
                'long-end1+short-end1':'56',
                'long-end2+short-end2':'56',
                'short-end1+long-center':'56',
                'short-end2+long-center':'56',
                'short-end1+long-end1':'56',
                'short-end2+long-end2':'56',
                'long-end2+short-end1':'56',
                'long-end1+short-end2':'56',
                'short-end2+long-end1':'56',
                'short-end1+long-end2':'56',
            },
            {},
            {}
        ]
    ,'PTH-42.128': [
            {
                'short-center':'52',
                'short-end':'60',
                'long-center':'60',
                'long-end':'60',
            },
            {
                'long-center+long-center':'52',
                'long-center+long-end1':'52',
                'long-center+long-end2':'52',
                'long-end1+long-center':'52',
                'long-end1+long-end1':'52',
                'long-end1+long-end2':'52',
                'long-end2+long-center':'52',
                'long-end2+long-end1':'52',
                'long-end2+long-end2':'52',
                'long-center+short-end1':'60',
                'long-center+short-end2':'60',
                'long-end1+short-end1':'60',
                'long-end2+short-end2':'60',
                'short-end1+long-center':'60',
                'short-end2+long-center':'60',
                'short-end1+long-end1':'60',
                'short-end2+long-end2':'60',
                'long-end2+short-end1':'60',
                'long-end1+short-end2':'60',
                'short-end2+long-end1':'60',
                'short-end1+long-end2':'60',
            },
            {},
            {}
        ]
    ,'PTH-42.134': [
            {
                'short-center':'56',
                'short-end':'64',
                'long-center':'64',
                'long-end':'64',
            },
            {
                'long-center+long-center':'56',
                'long-center+long-end1':'56',
                'long-center+long-end2':'56',
                'long-end1+long-center':'56',
                'long-end1+long-end1':'56',
                'long-end1+long-end2':'56',
                'long-end2+long-center':'56',
                'long-end2+long-end1':'56',
                'long-end2+long-end2':'56',
                'long-center+short-end1':'64',
                'long-center+short-end2':'64',
                'long-end1+short-end1':'64',
                'long-end2+short-end2':'64',
                'short-end1+long-center':'64',
                'short-end2+long-center':'64',
                'short-end1+long-end1':'64',
                'short-end2+long-end2':'64',
                'long-end2+short-end1':'64',
                'long-end1+short-end2':'64',
                'short-end2+long-end1':'64',
                'short-end1+long-end2':'64',
            },
            {},
            {}
        ]
    ,'PTH-42.140': [
            {
                'short-center':'58',
                'short-end':'66',
                'long-center':'66',
                'long-end':'66',
            },
            {
                'long-center+long-center':'58',
                'long-center+long-end1':'58',
                'long-center+long-end2':'58',
                'long-end1+long-center':'58',
                'long-end1+long-end1':'58',
                'long-end1+long-end2':'58',
                'long-end2+long-center':'58',
                'long-end2+long-end1':'58',
                'long-end2+long-end2':'58',
                'long-center+short-end1':'66',
                'long-center+short-end2':'66',
                'long-end1+short-end1':'66',
                'long-end2+short-end2':'66',
                'short-end1+long-center':'66',
                'short-end2+long-center':'66',
                'short-end1+long-end1':'66',
                'short-end2+long-end2':'66',
                'long-end2+short-end1':'66',
                'long-end1+short-end2':'66',
                'short-end2+long-end1':'66',
                'short-end1+long-end2':'66',
            },
            {},
            {}
        ]
    ,'PTH-42.146': [
            {
                'short-center':'60',
                'short-end':'68',
                'long-center':'68',
                'long-end':'68',
            },
            {
                'long-center+long-center':'60',
                'long-center+long-end1':'60',
                'long-center+long-end2':'60',
                'long-end1+long-center':'60',
                'long-end1+long-end1':'60',
                'long-end1+long-end2':'60',
                'long-end2+long-center':'60',
                'long-end2+long-end1':'60',
                'long-end2+long-end2':'60',
                'long-center+short-end1':'68',
                'long-center+short-end2':'68',
                'long-end1+short-end1':'68',
                'long-end2+short-end2':'68',
                'short-end1+long-center':'68',
                'short-end2+long-center':'68',
                'short-end1+long-end1':'68',
                'short-end2+long-end2':'68',
                'long-end2+short-end1':'68',
                'long-end1+short-end2':'68',
                'short-end2+long-end1':'68',
                'short-end1+long-end2':'68',
            },
            {},
            {}
        ]
    ,'PTH-42.152': [
            {
                'short-center':'64',
                'short-end':'72',
                'long-center':'72',
                'long-end':'72',
            },
            {
                'long-center+long-center':'64',
                'long-center+long-end1':'64',
                'long-center+long-end2':'64',
                'long-end1+long-center':'64',
                'long-end1+long-end1':'64',
                'long-end1+long-end2':'64',
                'long-end2+long-center':'64',
                'long-end2+long-end1':'64',
                'long-end2+long-end2':'64',
                'long-center+short-end1':'72',
                'long-center+short-end2':'72',
                'long-end1+short-end1':'72',
                'long-end2+short-end2':'72',
                'short-end1+long-center':'72',
                'short-end2+long-center':'72',
                'short-end1+long-end1':'72',
                'short-end2+long-end2':'72',
                'long-end2+short-end1':'72',
                'long-end1+short-end2':'72',
                'short-end2+long-end1':'72',
                'short-end1+long-end2':'72',
            },
            {},
            {}
        ]
    }
}

const topDownCameraDistances = {
    '24': {
        '26': 4,
        '32': 4,
        '38': 4,
        '44': 4.25,
        '50': 4.5,
        '56': 4.75,
        '62': 5.25,
        '68': 5.5,
        '74': 5.75,
        '80': 6,
        '86': 6.25,
        '92': 6.5,
        '98': 6.75,
        '104': 7,
        '110': 7.25,
        '116': 7.5,
        '122': 7.75,
        '128': 8.25,
        '134': 8.5,
        '140': 8.75,
        '146': 9,
        '152': 9.25
    },
    '30': {
        '26': 4.5,
        '32': 4.5,
        '38': 4.5,
        '44': 4.5,
        '50': 4.5,
        '56': 4.75,
        '62': 5.25,
        '68': 5.5,
        '74': 5.75,
        '80': 6,
        '86': 6.25,
        '92': 6.5,
        '98': 6.75,
        '104': 7,
        '110': 7.25,
        '116': 7.5,
        '122': 7.75,
        '128': 8.25,
        '134': 8.5,
        '140': 8.75,
        '146': 9,
        '152': 9.25

    },
    '36': {
        '26': 5,
        '32': 5,
        '38': 5,
        '44': 5,
        '50': 5,
        '56': 5,
        '62': 5.25,
        '68': 5.5,
        '74': 5.75,
        '80': 6,
        '86': 6.25,
        '92': 6.5,
        '98': 6.75,
        '104': 7,
        '110': 7.25,
        '116': 7.5,
        '122': 7.75,
        '128': 8.25,
        '134': 8.5,
        '140': 8.75,
        '146': 9,
        '152': 9.25
        
    },
    '42': {
        '26': 5.5,
        '32': 5.5,
        '38': 5.5,
        '44': 5.5,
        '50': 5.5,
        '56': 5.5,
        '62': 5.75,
        '68': 6,
        '74': 5.25,
        '80': 6.5,
        '86': 6.75,
        '92': 7,
        '98': 7.25,
        '104': 7.5,
        '110': 7.75,
        '116': 8.25,
        '122': 8.5,
        '128': 8.75,
        '134': 9,
        '140': 9.25,
        '146': 9.5,
        '152': 9.75

    },
    '48': {
        '26': 5.5,
        '32': 5.5,
        '38': 5.5,
        '44': 5.5,
        '50': 5.5,
        '56': 5.5,
        '62': 5.5,
        '68': 5.5,
        '74': 5.75,
        '80': 6,
        '86': 6.25,
        '92': 6.5,
        '98': 6.75,
        '104': 7,
        '110': 7.25,
        '116': 7.5,
        '122': 7.75,
        '128': 8.25,
        '134': 8.5,
        '140': 8.75,
        '146': 9,
        '152': 9.25

    }
}

export default SaveImage;